import React, { useState, useEffect, useCallback, useRef, useMemo } from "react";
import Navbar from '../../../common/navbar';
import SimilarCandidateCard from "./similarCandidateCard";
import { AiOutlineFormatPainter } from "react-icons/ai";
import WhatsAppModal from '../../../common/whatsAppModal';
import { FileText } from "lucide-react";
import ScreeningTabs from "./screeningTabs";
import {
  FiChevronRight,
  FiPaperclip,
  FiMail,
  FiBookmark,
  FiMessageCircle,
  FiAlertTriangle,
  FiBriefcase, FiCalendar, FiGlobe, FiInfo,FiMapPin 
} from "react-icons/fi";
import { FaWhatsapp, FaUserCheck } from "react-icons/fa";
import { IoSparkles } from "react-icons/io5";
import SkillBadge from "../../../common/skillBadge";
import { useLocation, useParams, Link } from "react-router-dom";
import ResumeModal from "../../../common/resumeModal";
import EmailModal from "../../../common/emailModal";
import { resumeUpload } from "../../../supports/resumeUpload";
import { getInitials } from "../../../common/common";
import Loader from "../../../common/loader";
import { RecruiterApi } from "../../../supports/recruiterApi";
import CommentModal from "../../../common/candidateCommentModal";
import unifiedAuthManager from "../../../services/unifiedAuthManager";
import FillMandatoryFieldsModal from "./fillMandatoryFieldsModal";
import { generateRequestId } from "../../../common/common";
import { FaBookmark as FaBookmarkFilled } from "react-icons/fa";
import { useToast } from "../../../common/toastSystem";
import remarkGfm from "remark-gfm";
import ReactMarkdown from "react-markdown";
import JobSelectionModal from "../../../common/jobSelectionModal";
import {  IoCheckmarkCircle, IoAlertCircle, IoInformationCircle } from 'react-icons/io5';

const PAGE_SIZE = 10;
const FORMATTED_CV_TYPES = [
  { label: "Standard", value: "standard" },
  { label: "Confidential", value: "confidential" },
];

const SkillsSection = ({ skills }) => {
  const [showAllSkills, setShowAllSkills] = useState(true);

  const skillsArray = Array.isArray(skills) ? skills : [];
  const visibleSkills = showAllSkills ? skillsArray : skillsArray.slice(0, 3);
  const hiddenCount = skillsArray.length - 3;


  return (
    <div className="grid gap-2 mt-4">
      {/* <span className="text-gray-999 text-xs">Skills & Expertise</span> */}
      <div className="flex flex-wrap gap-2 items-center">
        {visibleSkills.map((skill, idx) => (
          <SkillBadge key={`${skill}-${idx}`}>{skill}</SkillBadge>
        ))}

        {hiddenCount > 0 && !showAllSkills && (
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              setShowAllSkills(true);
            }}
            className="text-xs px-2 py-1 rounded-full border border-gray-200 cursor-pointer hover:bg-gray-100"
          >
            +{hiddenCount} more
          </button>
        )}

        {/* {showAllSkills && hiddenCount > 0 && (
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              setShowAllSkills(false);
            }}
            className="text-xs px-2 py-1 rounded-full border border-gray-200 cursor-pointer hover:bg-gray-100"
          >
            Show less
          </button>
        )} */}
      </div>
    </div>
  );
};

const normalizeSkillsPoints = (value) => {
  if (!value || typeof value !== "object" || Array.isArray(value)) return null;
  const entries = Object.entries(value).filter(
    ([key, points]) => key && Array.isArray(points) && points.length > 0
  );
  return entries.length > 0 ? Object.fromEntries(entries) : null;
};

const SkillsPointsSection = ({ skillsPoints }) => {
  const points = normalizeSkillsPoints(skillsPoints);
  if (!points) return null;

  return (
    <div className="mt-4 columns-1 sm:columns-2 xl:columns-3 gap-3">
      {Object.entries(points).map(([group, values]) => (
        <div
          key={group}
          className="mb-3 break-inside-avoid rounded-2xl border hover:border-emerald-100 bg-white p-3 shadow-sm hover:shadow-lg transition-all duration-200"
        >
          <h4 className="text-xs font-bold text-gray-800">{group}</h4>
          <div className="mt-2 flex flex-wrap gap-1.5">
            {values.map((item, index) => (
              <span
                key={`${group}-${index}`}
                className="rounded-full px-2 py-1 text-[11px] font-medium text-gray-800"
              >
               • {item}
              </span>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

// const EducationSection = ({ education }) => {
//   const [showAllSkills, setShowAllSkills] = useState(true);

//   const educationArray = Array.isArray(education) ? education : [];
//   const educationSkills = showAllSkills ? educationArray : educationArray.slice(0, 3);
//   const hiddenCount = educationArray.length - 3;

//   return (
//     <div className="grid gap-2 mt-4">
//       {/* <span className="text-gray-999 text-xs">Education</span> */}
//       <div className="flex flex-col">
//        <ul className="list-disc ml-4">
//   {educationSkills.map((education, idx) => (
//     <li
//       key={idx}
//       className="font-semibold text-xs px-2 py-1 rounded-full"
//     >
//       {education}
//     </li>
//   ))}
// </ul>


//         {hiddenCount > 0 && !showAllSkills && (
//           <button
//             type="button"
//             onClick={(e) => {
//               e.stopPropagation();
//               setShowAllSkills(true);
//             }}
//             className="text-xs px-2 py-1 rounded-full border border-gray-200 cursor-pointer hover:bg-gray-100"
//           >
//             +{hiddenCount} more
//           </button>
//         )}

//         {/* {showAllSkills && hiddenCount > 0 && (
//           <button
//             type="button"
//             onClick={(e) => {
//               e.stopPropagation();
//               setShowAllSkills(false);
//             }}
//             className="text-xs px-2 py-1 rounded-full border border-gray-200 cursor-pointer hover:bg-gray-100"
//           >
//             Show less
//           </button>
//         )} */}
//       </div>
//     </div>
//   );
// };

const EducationSection = ({ education }) => {
  // Set to false initially so the "more" button actually shows up
  const [showAllSkills, setShowAllSkills] = useState(false);

  const educationArray = Array.isArray(education) ? education : [];
  
  // Decide which items to show
  const displayItems = showAllSkills ? educationArray : educationArray.slice(0, 3);
  const hiddenCount = educationArray.length - 3;

  return (
    <div className="grid gap-2 mt-4">
      <div className="flex flex-col">
        <ul className="list-disc ml-4">
          {displayItems.map((edu, idx) => (
            <li key={idx} className="mb-2">
              <div className="flex flex-col">
                {/* Accessing object properties here */}
                <span className="font-semibold text-xs text-gray-900">
                  {edu.degree}
                </span>
                <span className="text-xs text-gray-500 pt-1">
                  {edu.institution} | {edu.duration_text}
                </span>
                <span className="text-xs text-gray-400 pt-1">
                  {edu.field || edu.major || edu.field_of_study|| '-'}
                </span>
              </div>
            </li>

          ))}
        </ul>

        {/* Show More Button */}
        {hiddenCount > 0 && !showAllSkills && (
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              setShowAllSkills(true);
            }}
            className="w-fit text-xs px-2 py-1 rounded-full border border-gray-200 cursor-pointer hover:bg-gray-100 mt-2"
          >
            +{hiddenCount} more
          </button>
        )}

        {/* Optional: Show Less Button */}
        {showAllSkills && educationArray.length > 3 && (
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              setShowAllSkills(false);
            }}
            className="w-fit text-xs px-2 py-1 rounded-full border border-gray-200 cursor-pointer hover:bg-gray-100 mt-2"
          >
            Show less
          </button>
        )}
      </div>
    </div>
  );
};
const BasicDetailsSection = ({ candidate, formatDate }) => {
  const [isOpen, setIsOpen] = useState(true);

  // Helper to extract and join languages
  const getLanguages = () => {
    const extract = (langArray) => {
      if (!Array.isArray(langArray)) return [];
      return langArray
        .map((langObj) => (typeof langObj === "object" ? langObj?.language : langObj))
        .filter((lang) => lang != null && lang !== "");
    };

    const allLangs = [
      ...extract(candidate.languages),
      ...extract(candidate.other_languages),
    ];
    return allLangs.length > 0 ? allLangs.join(", ") : "-";
  };

  return (
    <div className="pb-2">
      {/* Collapsible Grid Content */}
      {isOpen && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-y-5 gap-x-4 text-sm p-4 rounded-xl mb-4 animate-fadeIn">
          {/* Email */}
          <div>
            <p className="text-[11px]  tracking-wider font-semibold text-gray-400">
              Email ID
            </p>
            <p className="text-xs font-semibold text-gray-700 mt-1 break-all">
              {candidate?.email || "-"}
            </p>
          </div>

          {/* Contact */}
          <div>
            <p className="text-[11px]  tracking-wider font-semibold text-gray-400">
              Contact Number
            </p>
            <p className="text-xs font-semibold text-gray-700 mt-1 break-all">
              {candidate?.phone || "-"}
            </p>
          </div>

          {/* Gender */}
          <div>
            <p className="text-[11px]  tracking-wider font-semibold text-gray-400">
              Gender
            </p>
            <p className="text-xs font-semibold text-gray-700 mt-1 break-all">
              {candidate?.gender && candidate?.gender !== "None"
                ? candidate.gender
                : "-"}
            </p>
          </div>

          {/* Location */}
          <div>
            <p className="text-[11px]  tracking-wider font-semibold text-gray-400">
              Current Location
            </p>
            <p className="text-xs font-semibold text-gray-700 mt-1 break-all">
              {candidate?.location || candidate?.city || "-"}
            </p>
          </div>

          {/* Nationality */}
          <div>
            <p className="text-[11px]  tracking-wider font-semibold text-gray-400">
              Nationality
            </p>
            <p className="text-xs font-semibold text-gray-700 mt-1 break-all">
              {candidate?.nationality_disclosed ? (
                <span className="italic font-normal text-gray-500 text-[11px]">
                  Not disclosed
                </span>
              ) : (
                candidate?.nationality || "-"
              )}
            </p>
          </div>

          {/* Languages */}
          <div>
            <p className="text-[11px]  tracking-wider font-semibold text-gray-400">
              Languages Known
            </p>
            <p className="text-xs font-semibold text-gray-700 mt-1 break-all uppercase">
              {getLanguages()}
            </p>
          </div>

          {/* Sector */}
          <div>
            <p className="text-[11px] tracking-wider font-semibold text-gray-400">
              Sector
            </p>
            {/* <p className="text-xs font-semibold text-gray-700 mt-1 break-all">
              {Array.isArray(candidate?.sector_name)
                ? candidate.sector_name.join(", ")
                : candidate?.sector_name || "-"}
            </p> */}
            <p className="text-xs font-semibold text-gray-700 mt-1 break-words">
              {candidate?.sectors?.length
                ? candidate.sectors.join(", ")
                : "-"}
            </p>
          </div>

          {/* CV Origin */}
          <div>
            <p className="text-[11px] tracking-wider font-semibold text-gray-400">
              CV Origin
            </p>
            <p className="text-xs font-semibold text-gray-700 mt-1 break-all">
                {candidate.cv_origin && candidate.hub_source_id
                  ? `${candidate.cv_origin} (${candidate.hub_source_id})`
                  : candidate.cv_origin
                  ? candidate.cv_origin
                  : candidate.hub_source_id
                  ? `(${candidate.hub_source_id})`
                  : "-"
                }
            </p>
          </div>

          {/* Date of Birth */}
          <div className="relative">
            <p className="text-[11px] tracking-wider font-semibold text-gray-400">
              Date of Birth
            </p>
            <div className="flex items-center gap-1 mt-1">
              <p className="text-xs font-semibold text-gray-700 break-all">
                {candidate.date_of_birth
                  ? formatDate(candidate?.date_of_birth)
                  : "-"}
              </p>
              {candidate.is_assumed_dob && (
                <div className="group relative">
                  <FiInfo size={12} className="text-amber-500 cursor-help" />
                  <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-48 p-2 bg-gray-800 text-white text-[10px] rounded opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-50">
                    Estimated by AI from profile data
                  </span>
                </div>
              )}
            </div>
          </div>

          {/* Created Date */}
          <div>
            <p className="text-[11px] tracking-wider font-semibold text-gray-400">
              Created Date
            </p>
            <p className="text-xs font-semibold text-gray-700 mt-1 break-all">
              {candidate.created_at ? formatDate(candidate?.created_at) : "-"}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};


const WorkExperienceSection = ({ experience }) => {
  if (!experience || experience.length === 0) {
    return <p className="text-sm text-gray-500 italic p-4">No work experience details provided.</p>;
  }

  return (
    <div className="relative space-y-4 px-2 py-2">
      {/* Vertical Timeline Line */}
      <div className="absolute left-[26px] top-8 bottom-4 w-0.5 bg-gray-100"></div>

      {experience.map((job, index) => {
        const isCurrent = job?.duration?.toLowerCase().includes('present');
        
        return (
          <div key={index} className="relative pl-12 animate-fadeIn">
            {/* Timeline Dot */}
            <div className={`absolute left-0 top-1 w-10 h-10 rounded-full border-4 border-white flex items-center justify-center z-10 shadow-sm ${
              isCurrent ? 'bg-emerald-100 text-emerald-600' : 'bg-gray-100 text-gray-500'
            }`}>
              <FiBriefcase size={16} />
            </div>

            <div className={`p-2 rounded-xl border transition-all ${
              isCurrent ? 'border-emerald-100 bg-emerald-50/30' : 'border-gray-100 bg-white hover:border-gray-200'
            }`}>
              {/* Header: Title and Duration */}
              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 mb-1">
                <h3 className="font-bold text-gray-800 text-xs leading-tight">
                  {job.title}
                </h3>
                <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[10px] font-bold tracking-wider ${
                  isCurrent ? 'bg-gradient text-white' : 'bg-gray-100 text-gray-600'
                }`}>
                  <FiCalendar size={12} />
                  {job.duration}
                </span>
              </div>

              {/* Company Info */}
              <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-gray-600">
                <span className="flex items-center gap-1.5 font-semibold">
                    <FiMapPin  size={12} className="text-gray-400" />
                  {job.company}
                </span>
                
                {job.company_sector && (
                  <span className="flex items-center gap-1.5 text-gray-500 italic">
                    <FiGlobe size={12} className="text-gray-400" />
                    {job.company_sector}
                  </span>
                )}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

const Breadcrumb = ({ candidateName, query, searchType }) => (
  <div className="flex items-center gap-2 text-sm text-gray-666">
    <Link
      to={{
        pathname: "/candidates",
        search:
          query && searchType
            ? `?query=${encodeURIComponent(query)}&type=${encodeURIComponent(
                searchType
              )}`
            : "",
      }}
      className="hover:underline"
    >
      Candidates
    </Link>
    <FiChevronRight size={14} />
    <span className="font-semibold mph-primary">{candidateName}</span>
  </div>
);

const CandidateDetailPage = ({
  candidate: propCandidate,
  pageType = "standard",
  similarCandidates: propSimilarCandidates,
  jobTitle: propJobTitle,
  onViewAll,
  onCandidateChange,
  jobId: propJobId,
  llmScore,
  jobMphId,
  jobDetails: propJobDetails,
  onUpdateCandidate,
  onUpdateAttribute
}) => {
  const isMatching = pageType === "matching";
  const [showResumeModal, setShowResumeModal] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [sendingEmail, setSendingEmail] = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [resumeUrl, setResumeUrl] = useState(null);
  const [resumeFileType, setResumeFileType] = useState(null);
  const [resumeLoading, setResumeLoading] = useState(false);
  const [resumeError, setResumeError] = useState("");
  const [apiCandidate, setApiCandidate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fetchedSimilarCandidates, setFetchedSimilarCandidates] = useState([]);
  const [fetchingSimilar, setFetchingSimilar] = useState(false);
  const [showWhatsAppModal, setShowWhatsAppModal] = useState(false);
  const [sendingWhatsApp, setSendingWhatsApp] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  const isFetchingRef = useRef(false);
  const [pageNum, setPageNum] = useState(0);
  const pageNumRef = useRef(0);
  const similarListRef = useRef(null);
  const params = useParams();
  const id = params.candidateId;
  const location = useLocation();
  const [matchingCandidate, setMatchingCandidate] = useState(
    isMatching ? propCandidate : null
  );
  const [candidateId, setCandidateId] = useState(
    id || (isMatching && propCandidate?.id)
  );
 const [jobId, setJobId] = useState(
  propJobId ??
  (isMatching ? propJobDetails?.id ?? null : null) ??
  propJobDetails?.id ??
  null
);
  const pathParts = location.pathname.split("/").filter(Boolean);
  const mode = pathParts[0];
    const hasSearchParams = Boolean(location.search);
  const isSearchingRef = useRef(false);
  const isSendingEmailRef = useRef(false);
  const searchParams = new URLSearchParams(location.search);
  const query = searchParams.get("query") || "";
  const searchType = searchParams.get("type") || "";
  const candidateFetchControllerRef = useRef(null);
  const [showCommentModal, setShowCommentModal] = useState(false);
  const [comment, setComment] = useState("");
  const [savedComment, setSavedComment] = useState("");
  const [goodFitData, setGoodFitData] = useState([]);
  const [prerequisiteQuestions, setPrerequisiteQuestions] = useState([]);
  const [goodFitLoading, setGoodFitLoading] = useState(false);
  const user = unifiedAuthManager.getUnifiedUser();
  const recruiterId = user?.id;
  const isFetchingInsightsRef = useRef(false);
  const latestFetchInsightsRequestRef = useRef(0);
  const [expanded, setExpanded] = useState(false);
  const [showCVModal, setShowCVModal] = useState(false);
  const [showFormattedCVTypeModal, setShowFormattedCVTypeModal] = useState(false);
  const [formattedCVType, setFormattedCVType] = useState("");
  const [submittingToAM, setSubmittingToAM] = useState(false);
  const [showFillModal, setShowFillModal] = useState(false);
  const [isSidebarExpanded, setIsSidebarExpanded] = useState(false);
	  const [isBookmarked, setIsBookmarked] = useState(propCandidate?.is_tagged);
	  const [bookmarkLoading, setBookmarkLoading] = useState(false);
	  const [candidateData, setCandidateData] = useState(propCandidate);
	  const [whatsAppThreadCount, setWhatsAppThreadCount] = useState(null);
	  const toast = useToast();
	  const [showWarningTooltip, setShowWarningTooltip] = useState(false);
	  const [viewLoading, setViewLoading] = useState(false);
  const [formattedCVUrl, setFormattedCVUrl] = useState(null);
  const [formattedCVLoading, setFormattedCVLoading] = useState(false);
  const [formattedCVError, setFormattedCVError] = useState("");
  const [localJobDetails, setLocalJobDetails] = useState(
    propJobDetails || null
  );
  const [jobDetailsLoading, setJobDetailsLoading] = useState(false);
  const isFetchingJobDetailsRef = useRef(false);
  const [jobDetailsError, setJobDetailsError] = useState("");
  const [isAllJobsLoading, setIsAllJobsLoading] = useState(false);
  const [currentJobs, setCurrentJobs] = useState([]);
  const [showJobsModal, setShowJobsModal] = useState(false);
  const [mphJobId, setMphJobId] = useState("");
  const [selectedJobForApplicant, setSelectedJobForApplicant] = useState("");
  const [emailType, setEmailType] = useState("");
  const smartMatchRequestRef = useRef(false);
  const [currentMenu,setCurrentMenu] = useState('Details');

  const [activeTab, setActiveTab] = useState('Work Experience');
  const [skillsPointsData, setSkillsPointsData] = useState(null);
  const [skillsPointsLoading, setSkillsPointsLoading] = useState(false);
  const skillsPointsFetchTrackerRef = useRef({});
				
	  const [candidateApplication,setCandidateApplication] = useState(null);

	  const candidateIdForWhatsApp = candidateData?.id || candidateId;
	  useEffect(() => {
	    if (!candidateIdForWhatsApp) {
	      setWhatsAppThreadCount(null);
	      return;
	    }

	    let cancelled = false;
	    RecruiterApi.getCandidateWhatsAppConversations(candidateIdForWhatsApp)
	      .then((res) => {
	        const count = Array.isArray(res?.conversations) ? res.conversations.length : 0;
	        if (!cancelled) setWhatsAppThreadCount(count);
	      })
	      .catch(() => {
	        if (!cancelled) setWhatsAppThreadCount(null);
	      });

	    return () => {
	      cancelled = true;
	    };
	  }, [candidateIdForWhatsApp]);
	  const modalSizeClass = expanded
	    ? "w-full h-full max-w-none max-h-none"
	    : "w-full h-full max-w-none max-h-none";
  const modalPaddingClass = expanded ? "p-2 md:p-6" : "p-2 md:p-6";
  const modalContainerClass = expanded
    ? "fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40"
    : "fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30";

  const gridColsClass = expanded
    ? "grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-6"
    : "grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-6";
  const iframeHeightClass = expanded
    ? "h-[80vh] md:h-[85vh]"
    : "h-[80vh] md:h-[85vh]";

  const fetchCandidateInsights = useCallback(
    async (
      providedCandidateId = candidateId,
      providedJobId = jobId,
      jobMphId = jobDetails?.mph_jobid ?? null
    ) => {
      let cancelled = false;
      const fetchRequestId = ++latestFetchInsightsRequestRef.current;
      if (isFetchingInsightsRef.current) return;
      isFetchingInsightsRef.current = true;
      setGoodFitLoading(true);
      try {
        const response = await RecruiterApi.getCandidateInsights({
          user_payload: {
            user_id: recruiterId,
            request_id: generateRequestId(),
            email: "wjdhd",
            tenant: "GBB",
          },
          payload: {
            job_id: parseInt(providedJobId),
            candidate_id: parseInt(providedCandidateId),
            mph_jobId: jobMphId,
          },
        });
        if (response && response.success) {
          const data = response.data;
          setGoodFitData(
            Array.isArray(data.reason_for_match_score)
              ? data.reason_for_match_score
              : []
          );
          setPrerequisiteQuestions(data);
        } else {
          setGoodFitData([]);
          setPrerequisiteQuestions([]);
        }
      } catch {
        setGoodFitData([]);
        setPrerequisiteQuestions([]);
      } finally {
        setGoodFitLoading(false);
        isFetchingInsightsRef.current = false;
      }
      return () => {
        cancelled = true;
      };
    },
    [candidateId, jobId, recruiterId]
  );

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const searchType = urlParams.get("type") || "";
    if (!candidateId) {
      setGoodFitData([]);
      setPrerequisiteQuestions([]);
      return;
    }
    if (searchType === "dropdown") {
      return;
    }
    fetchCandidateInsights();
  }, [candidateId, jobId, recruiterId, searchType]);

  useEffect(() => {
    if (
      searchType === "dropdown" &&
      candidateId &&
      localJobDetails &&
      localJobDetails.id // ensure job id is available
    ) {
      fetchCandidateInsights(
        candidateId,
        localJobDetails.id,
        localJobDetails.mph_jobid
      );
    }
  }, [
    searchType,
    candidateId,
    localJobDetails,
    localJobDetails?.id,
    recruiterId,
  ]);

  useEffect(() => {
    if (!candidateId) return;

    const urlParams = new URLSearchParams(window.location.search);
    let jobIdFromUrl = "";
    const searchType = urlParams.get("type") || "";
    const query = urlParams.get("query") || "";
    if (searchType === "dropdown" && query) {
      const matches = query.match(/\(?(JO\d+)\)?/i);
      if (matches && matches[1]) {
        jobIdFromUrl = matches[1];
      }
    }

    const doFetch = async () => {
      if (searchType === "dropdown" && jobIdFromUrl && !localJobDetails) {
        if (isFetchingJobDetailsRef.current) {
          return;
        }
        isFetchingJobDetailsRef.current = true;
        fetchJobDetails(jobIdFromUrl);
      } else {
        if (candidateFetchControllerRef.current) {
          candidateFetchControllerRef.current.abort();
        }
        const controller = new AbortController();
        candidateFetchControllerRef.current = controller;
        getCandidateDetails(candidateId, controller.signal, true).finally(
          () => {
            candidateFetchControllerRef.current = null;
          }
        );
      }
    };

    doFetch();
    getCandidateApplication()
  }, [candidateId]);

  const getCandidateDetails = async (
    candidateId,
    signal,
    is_recruiter = false
  ) => {
    if (!candidateId) return;
    setLoading(true);
    const requestBody = {
      candidate_id: candidateId,
      mph_jobid: jobDetails?.mph_jobid ?? null,
      is_recruiter: is_recruiter,
      user_payload: {
        request_id: generateRequestId(),
        email: "lakshmi@outlook.com",
      },
    };
    try {
      const response = await resumeUpload.getCandidateDetailsRecruiter(
        requestBody,
        signal
      );
      setLoading(false);
      if (response && response.success) {
        setApiCandidate(response.data);
        if (isMatching) {
          setMatchingCandidate(response.data);
        }
      } else {
        setApiCandidate(null);
        if (isMatching) {
          setMatchingCandidate(null);
        }
      }
    } catch (err) {
      if (err.name === "AbortError") {
        return;
      }
      setApiCandidate(null);
      if (isMatching) {
        setMatchingCandidate(null);
      }
    }
  };

 const extractPositionName = (title) => {
    return title.split(' - ')[0].trim();
  };

    const getStatusColor = (status) => {
    switch (status) {
      case 'Placed':
        return 'bg-green-100 text-green-800';
      case 'Rejected By Sourcer':
        return 'bg-red-100 text-red-800';
      case 'Demobilized':
        return 'bg-gray-100 text-gray-800';
      default:
        return 'bg-blue-100 text-blue-800';
    }
  };

const formatDate = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = date.toLocaleString("en-US", { month: "short" });
  const year = date.getFullYear();

  return `${day} ${month} ${year}`;
};


  const isValidMobileNumber = () => {
    if (!candidate?.phone) return false;
    const phoneStr = String(candidate?.phone).trim();
    // Extract only digits and check if there are at least 2
    const digits = phoneStr.replace(/\D/g, '');
    return digits.length >= 2;
  };

  
  const searchCandidates = useCallback(async (searchQuery) => {
    if (!searchQuery) return;
    if (isSearchingRef.current) return;
    isSearchingRef.current = true;
    setFetchingSimilar(true);
    try {
      const response = await RecruiterApi.searchCandidates({
        user_payload: { request_id: generateRequestId() },
        search_text: searchQuery,
      });
      if (
        response &&
        response.success &&
        Array.isArray(response.data?.candidates)
      ) {
        setFetchedSimilarCandidates(response.data.candidates);
      } else {
        setFetchedSimilarCandidates([]);
      }
    } catch {
      setFetchedSimilarCandidates([]);
    } finally {
      setFetchingSimilar(false);
      isSearchingRef.current = false;
    }
  }, []);

  const fetchCandidates = useCallback(async (pageNumToFetch = 0) => {
    if (isFetchingRef.current) return;
    isFetchingRef.current = true;
    setFetchingSimilar(true);
    try {
      const response = await RecruiterApi.getCandidates({
        user_payload: { request_id: generateRequestId() },
        page: pageNumToFetch,
        count: PAGE_SIZE,
      });
      if (response.success) {
        const newCandidates = response.data.candidates || [];
        setFetchedSimilarCandidates((prev) =>
          pageNumToFetch === 0 ? newCandidates : [...prev, ...newCandidates]
        );
        setHasMore(newCandidates.length === PAGE_SIZE);
      } else {
        setFetchedSimilarCandidates([]);
        setHasMore(false);
      }
    } catch {
      setFetchedSimilarCandidates([]);
      setHasMore(false);
    } finally {
      setFetchingSimilar(false);
      isFetchingRef.current = false;
    }
  }, []);

  const handleDownloadFormattedResumeClick = async () => {
    try {
      const requestBody = {
        candidate_id: candidate.id.toString(),
        user_payload: {
          request_id: generateRequestId(),
        },
        flag: "download",
        type: formattedCVType,
      };

      const response = await RecruiterApi.getFormattedResumePreview?.(
        requestBody
      );
      console.log("Download response:", response);

      const sasUrl = response?.data?.data?.sas_token_url?.trim();
      if (sasUrl) {
        const downloadUrl = sasUrl.replace(/ /g, "%20");

        const a = document.createElement("a");
        a.href = downloadUrl;
        a.download = "";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        toast.success("Download started...");
      } else {
        toast.warning(
          "Failed to download resume else. Please try again later."
        );
      }
    } catch (error) {
      console.error("Error downloading resume:", error);
      toast.warning("Failed to download resumeeee. Please try again later.");
    } finally {
      setViewLoading(false);
    }
  };

  const handleViewFormattedResumeClick = async () => {
    try {
      console.log("reached view formatted");
      const requestBody = {
        candidate_id: candidate.id.toString(),
        user_payload: {
          request_id: generateRequestId(),
        },
        flag: "view",
        type: formattedCVType,
      };

      const response = await RecruiterApi.getFormattedResumePreview?.(
        requestBody
      );
      console.log("View response:", response);

      if (
        response &&
        response.data.status &&
        response.data?.data?.sas_token_url
      ) {
        let viewUrl = response?.data?.data?.sas_token_url.trim();

        viewUrl = viewUrl.replace(/ /g, "%20");

        const fileUrl = viewUrl.toLowerCase().endsWith(".docx")
          ? `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
              viewUrl
            )}`
          : viewUrl;

        console.log("Opening resume:", fileUrl);
        window.open(fileUrl, "_blank", "noopener,noreferrer");
      } else {
        console.log("Invalid response or missing SAS URL:", response);
        toast.warning("Failed to open resume. Please try again later.");
      }
    } catch (error) {
      console.error("Error opening resume:", error);
      console.log("this is error", error);
      toast.warning(
        "Failed to open in exception resume. Please try again later."
      );
    } finally {
      setViewLoading(false);
    }
  };

  const handleViewResumeClick = async () => {
    console.log("Reached view");

    try {
      const requestBody = {
        candidate_id: candidate.id.toString(),
        user_payload: {
          request_id: generateRequestId(),
        },
        flag: "view",
      };

      const response = await RecruiterApi.getResumePreview?.(requestBody);
      console.log("View response:", response);
      if (response && response?.success && response?.data?.sas_token_url) {
        let viewUrl = response?.data?.sas_token_url.trim();

        viewUrl = viewUrl.replace(/ /g, "%20");

        const fileUrl = viewUrl.toLowerCase().endsWith(".docx")
          ? `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
              viewUrl
            )}`
          : viewUrl;

        console.log("Opening resume:", fileUrl);
        window.open(fileUrl, "_blank", "noopener,noreferrer");
      } else {
        console.log("Invalid response or missing SAS URL:", response);
        toast.warning("Failed to open resume. Please try again later.");
      }
    } catch (error) {
      console.error("Error opening resume:", error);
      console.log("this is error", error);
      toast.warning(
        "Failed to open in exception resume. Please try again later."
      );
    } finally {
      setViewLoading(false);
    }
  };

  const handleDownloadResumeClick = async () => {
    console.log("Reached download");

    try {
      const requestBody = {
        candidate_id: candidate.id.toString(),
        user_payload: {
          request_id: generateRequestId(),
        },
        flag: "download",
      };

      const response = await RecruiterApi.getResumePreview?.(requestBody);
      console.log("Download response:", response);

      if (response && response.success && response.data?.sas_token_url) {
        let downloadUrl = response.data.sas_token_url.trim();

        downloadUrl = downloadUrl.replace(/ /g, "%20");

        console.log("Opening download link:", downloadUrl);

        window.open(downloadUrl, "_blank", "noopener,noreferrer");

        toast.success("Download started...");
      } else {
        console.log("Invalid response or missing SAS URL:", response);
        toast.warning("Failed to download resume. Please try again later.");
      }
    } catch (error) {
      console.error("Error downloading resume:", error);
      toast.warning("Failed to download resume. Please try again later.");
    } finally {
      setViewLoading(false);
    }
  };

  // --- CHANGED: handleSmartMatchForJob remains unchanged
  const handleSmartMatchForJob = async (jobId) => {
    if (!jobId) return;
    if (smartMatchRequestRef.current) return;
    smartMatchRequestRef.current = true;
    setFetchingSimilar(true);
    try {
      const response = await RecruiterApi.getSmartMatchCandidates({
        user_payload: {
          request_id: generateRequestId(),
          email: user?.email,
          tenant: "",
          user_id: user?.id,
        },
        payload: {
          job_id: jobId,
        },
      });
      if (response && response.success && Array.isArray(response.data?.hits)) {
        setFetchedSimilarCandidates(response.data.hits);
        const tagged = response.data.hits.find(
          (c) => String(c.id) === String(candidateId)
        );
        setIsBookmarked(tagged?.is_tagged ?? false);
      } else {
        setFetchedSimilarCandidates([]);
      }
    } catch (err) {
      setFetchedSimilarCandidates([]);
    } finally {
      setFetchingSimilar(false);
      smartMatchRequestRef.current = false;
    }
  };

  const fetchJobDetails = async (id) => {
    try {
      if (!isFetchingJobDetailsRef.current) {
        isFetchingJobDetailsRef.current = true;
      }
      setJobDetailsLoading(true);
      setJobDetailsError("");
      const response = await RecruiterApi.getJobDetails({
        job_id: id,
        user_payload: { request_id: generateRequestId() },
        email: user.email,
      });
      setJobDetailsLoading(false);
      if (jobId) return;
      if (response.success) {
        setLocalJobDetails(response.data);
        setJobId(response.data.id); // Set the jobId state here
        setJobDetailsError("");
        if (candidateFetchControllerRef.current) {
          candidateFetchControllerRef.current.abort();
        }
        const controller = new AbortController();
        candidateFetchControllerRef.current = controller;
        getCandidateDetails(candidateId, controller.signal, false).finally(
          () => {
            candidateFetchControllerRef.current = null;
          }
        );
        handleSmartMatchForJob(response.data.id);
      } else {
        setLocalJobDetails(null);
        setJobDetailsError("Failed to load job details.");
      }
    } catch (error) {
      setJobDetailsLoading(false);
      console.error("Error fetching job details:", error);
      setLocalJobDetails(null);
      setJobDetailsError("Failed to load job details. Please try again.");
    } finally {
      isFetchingJobDetailsRef.current = false;
    }
  };

  useEffect(() => {
    if (!isMatching && searchType !== "dropdown") {
      if (query) {
        if (!isSearchingRef.current) {
          searchCandidates(query);
        }
      } else {
        if (!isFetchingRef.current) {
          setPageNum(0);
          pageNumRef.current = 0;
          fetchCandidates(0);
        }
      }
    }
    // eslint-disable-next-line
  }, [isMatching, query, searchCandidates, fetchCandidates]);

  useEffect(() => {
    if (isMatching || query || searchType == "dropdown") {
      return;
    }
    
    const handleScroll = () => {
      const el = similarListRef.current;
      if (!el || fetchingSimilar || !hasMore) {
        return;
      }
      const distanceFromBottom = el.scrollHeight - el.scrollTop - el.clientHeight;
      if (distanceFromBottom < 60) {
        if (!isFetchingRef.current) {
          const nextPage = pageNumRef.current + 1;
          pageNumRef.current = nextPage;
          setPageNum(nextPage);
          fetchCandidates(nextPage);
        }
      }
    };
    
    // Try to find the scrollable element - it might be in the sidebar or elsewhere
    const findScrollableElement = () => {
      // First try the ref
      if (similarListRef.current) {
        return similarListRef.current;
      }
      // If sidebar is expanded, try to find the div in the aside
      if (isSidebarExpanded) {
        const aside = document.querySelector("aside[class*='anim-slideLeft']");
        if (aside) {
          const scrollDiv = aside.querySelector("[class*='overflow-y-auto']");
          if (scrollDiv) {
            return scrollDiv;
          }
        }
      }
      return null;
    };
    
    const el = findScrollableElement();
    if (el) {
      el.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (el) {
        el.removeEventListener("scroll", handleScroll);
      }
    };
    // eslint-disable-next-line
  }, [isMatching, query, fetchCandidates, fetchingSimilar, hasMore, isSidebarExpanded]);

  let candidate, similarCandidates, jobTitle;
  if (candidateId && !isMatching) {
    candidate = apiCandidate;
    similarCandidates = fetchedSimilarCandidates;
    jobTitle = "";
  } else if (isMatching) {
    candidate = matchingCandidate;
    similarCandidates = propSimilarCandidates || [];
    jobTitle = propJobTitle || "";
  } else {
    const {
      mockDetailedCandidate,
    } = require("../../../data/mockDetailedCandidate");
    const {
      mockSimilarCandidates,
    } = require("../../../data/mockSimilarCandidates");
    candidate = mockDetailedCandidate;
    similarCandidates =
      fetchedSimilarCandidates.length > 0
        ? fetchedSimilarCandidates
        : mockSimilarCandidates;
    jobTitle = "Job Name";
  }

  const inlineSkillsPoints = useMemo(
    () =>
      normalizeSkillsPoints(
        (isMatching ? matchingCandidate?.skills_points : apiCandidate?.skills_points) ||
        propCandidate?.skills_points
      ),
    [
      isMatching,
      matchingCandidate?.skills_points,
      apiCandidate?.skills_points,
      propCandidate?.skills_points,
    ]
  );

  useEffect(() => {
    setSkillsPointsData(inlineSkillsPoints || null);
  }, [inlineSkillsPoints, candidateId]);

  const fetchCandidateSkillsPoints = useCallback(async () => {
    if (!candidateId) return;
    setSkillsPointsLoading(true);
    try {
      // Hook for upcoming API integration. Add RecruiterApi.getCandidateSkillsPoints once backend is ready.
      const response = await RecruiterApi.getCandidateSkillsPoints?.({
        user_payload: {
          user_id: recruiterId,
          request_id: generateRequestId(),
          email: user?.email,
          tenant: "GBB",
        },
        candidate_id: parseInt(candidateId),
      });

      const apiSkillsPoints = normalizeSkillsPoints(
        response?.data?.skills_points || response?.data
      );
      if (apiSkillsPoints) {
        setSkillsPointsData(apiSkillsPoints);
      }
    } catch (error) {
      console.log("skills_points hook call failed", error);
    } finally {
      setSkillsPointsLoading(false);
    }
  }, [candidateId, recruiterId, user?.email]);

  useEffect(() => {
    if (activeTab !== "Skills & Expertise") return;
    if (skillsPointsData) return;
    if (!candidateId) return;
    if (skillsPointsFetchTrackerRef.current[candidateId]) return;

    skillsPointsFetchTrackerRef.current[candidateId] = true;
    fetchCandidateSkillsPoints();
  }, [activeTab, skillsPointsData, candidateId, fetchCandidateSkillsPoints]);

  const jobDetails =
    searchType === "dropdown" && localJobDetails
      ? localJobDetails
      : propJobDetails;

  let isSubmitted;
  if (searchType === "dropdown" && Array.isArray(similarCandidates)) {
    const matchedSim = similarCandidates.find(
      (sim) => String(sim.id) === String(candidateId)
    );
    isSubmitted = !!(matchedSim && matchedSim.is_submitted);
  } else {
    isSubmitted =
      !!(propCandidate && propCandidate.is_submitted) ||
      !!(candidate && candidate.is_submitted);
  }

  const iconButtonStyles =
    "h-8 w-8 flex items-center justify-center border border-gray-200 rounded-full mph-primary hover:bg-gray-100";

  const handleOpenResume = async (e) => {
    e.stopPropagation();
    setResumeError("");
    setResumeLoading(true);
    setShowResumeModal(true);
    const controller = new AbortController();
    const signal = controller.signal;
    handleOpenResume.controller = controller;
    try {
      const response = await RecruiterApi.getResumePreview(
        {
          user_payload: { request_id: generateRequestId() },
          candidate_id: candidate.id,
        },
        signal
      );
      setResumeLoading(false);
      if (response.success) {
        setResumeUrl(response.data.sas_token_url);
        setResumeFileType(response.data.filetype || null);
      } else {
        setResumeUrl(null);
        setResumeFileType(null);
      }
    } catch {
      setResumeError("Failed to load resume. Please try again.");
      setResumeUrl(null);
      setResumeFileType(null);
    } finally {
      setResumeLoading(false);
    }
  };

  useEffect(() => {
    return () => {
      if (handleOpenResume.controller) {
        handleOpenResume.controller.abort();
      }
    };
  }, []);

  const handleCloseResume = () => {
    setShowResumeModal(false);
    setResumeUrl(null);
    setResumeError("");
    setResumeFileType(null);
  };

  const handleOpenEmail = (e) => {
    e.stopPropagation();
    setShowEmailModal(true);
    setEmailSent(false);
    setEmailError("");
  };

  const handleCloseEmail = () => {
    setShowEmailModal(false);
    setEmailSent(false);
    setEmailError("");
  };

  const handleSendEmail = async (body) => {
    setSendingEmail(true);
    setEmailError("");
    try {
      const response = await RecruiterApi.sendMail(body);
      if (response.success) {
        if (response.data) {
	          candidate.is_email_sent = true;
	          candidate.email_sent_at = response?.data.email_sent_at || null;
	          setCandidateData((prev) => ({
	            ...(prev || {}),
	            is_email_sent: true,
	            email_sent_at: response?.data.email_sent_at || null,
	          }));
	          if (onUpdateCandidate) {
	            onUpdateCandidate(candidate);
          }
          toast.success(response.message || "Email sent successfully");
        }
      } else {
        toast.warning(
          response.message || "Failed to send email. Please try again."
        );
      }
      setEmailSent(true);
    } catch (err) {
      setEmailError("Failed to send email. Please try again.");
    } finally {
      setShowEmailModal(false);
      setSendingEmail(false);
    }
  };
  const handleSendSearchEmail = async (body) => {
    setSendingEmail(true);
    setEmailError("");
    try {
      let payload = {
        candidate_ids: [body.candidate_id],
        subject: body.subject,
        email_body: body.email_body,
        sender_email:user.email // can be dynamic based on logged in user
      };
      const response = await RecruiterApi.sendSearchMail(payload);
      console.log(response);

      if (response.success) {
        if (response.data) {
          const sentAt = response?.data?.email_sent_at || null;
          candidate.is_email_sent = true;
          candidate.generic_email_sent_at = sentAt;
          toast.success(response.message || "Email sent successfully");
        }
      } else {
        toast.warning(
          response.message || "Failed to send email. Please try again."
        );
      }
      setEmailSent(true);
    } catch (err) {
      setEmailError("Failed to send email. Please try again.");
    } finally {
      setShowEmailModal(false);
      setSendingEmail(false);
    }
  };
  const handleCandidateSelect = (candidate) => {
    setCandidateId(candidate.id);
    if (isMatching || searchType == "dropdown") {
      setMatchingCandidate(candidate);
      setIsBookmarked(!!candidate.is_tagged);
    }
    if (typeof onCandidateChange === "function") {
      onCandidateChange(candidate);
    }
  };

  const handleViewAllClick = (e) => {
    if (isMatching) {
      e.preventDefault();
      if (typeof onViewAll === "function") {
        onViewAll(true);
      }
    }
  };

  const handleOpenComment = () => {
    setShowCommentModal(true);
    setComment(savedComment || "");
  };

  const handleCloseComment = () => {
    setShowCommentModal(false);
  };

  const handleUpdateComment = (candidateId) => {
    candidate.comment_count = candidateId.updatedCount;
  };
  const handleSaveComment = () => {
    setSavedComment(comment);
    setShowCommentModal(false);
  };

  const handleOpenFormattedCVTypeModal = (e) => {
    if (e && e.stopPropagation) e.stopPropagation();
    setShowFormattedCVTypeModal(true);
  };

  const handleCloseFormattedCVTypeModal = () => {
    setShowFormattedCVTypeModal(false);
  };

  const handleShowCVModal = async (type, e) => {
    if (e && e.stopPropagation) e.stopPropagation();
    setFormattedCVType(type);
    setShowFormattedCVTypeModal(false);
    setExpanded(false);
    if (!resumeUrl) {
      setResumeError("");
      setResumeLoading(true);
      const controller = new AbortController();
      const signal = controller.signal;
      try {
        const response = await RecruiterApi.getResumePreview(
          {
            user_payload: { request_id: generateRequestId() },
            candidate_id: candidate.id,
          },
          signal
        );
        if (response.success) {
          setResumeUrl(response.data.sas_token_url);
          setResumeFileType(response.data.filetype || null);
        } else {
          setResumeUrl(null);
          setResumeFileType(null);
        }
      } catch (err) {
        if (err.name !== "AbortError") {
          setResumeError("Failed to load resume. Please try again.");
          setResumeUrl(null);
          setResumeFileType(null);
        }
      } finally {
        setResumeLoading(false);
      }
    }
    setShowCVModal(true);
    setFormattedCVLoading(true);
    setFormattedCVError("");

    try {
      const response = await RecruiterApi.formattedCV({
        request_id: generateRequestId(),
        candidate_id: candidate.id.toString(),
        email: candidate.email,
        tenant: "GBB",
        sector: candidate.sector_name,
        template_path: "/app/cvtemplate/MPH_Confidential_template.docx",
        new_template_path: "/app/cvtemplate/MPH_Standard_template.docx",
        type,
      });

      if (response && response.success && response.data?.data) {
        setFormattedCVUrl(response.data.data);
      } else if (
        response &&
        response.success &&
        response.data?.cv_origin_link?.sas_token_url
      ) {
        setFormattedCVUrl(response.data.cv_origin_link.sas_token_url);
      } else {
        setFormattedCVError("Failed to load formatted CV");
        setFormattedCVUrl(null);
      }
    } catch (error) {
      setFormattedCVError("Failed to load formatted CV");
      setFormattedCVUrl(null);
    } finally {
      setFormattedCVLoading(false);
    }
  };

  const handleCloseCVModal = () => {
    setShowCVModal(false);
    setExpanded(false);
  };

  const handleConfirmSubmitToAM = () => {
    if (!isMatching) {
      if (isAllJobsLoading) return;
      setIsAllJobsLoading(true);
      fetchAllJobs();
    } else {
      setMphJobId(jobMphId);
      handleSubmitWithMandatoryFields();
    }
  };

  const fetchAllJobs = async () => {
    try {
      let payload = {
        user_payload: {
          request_id: generateRequestId(),
          email: candidate.email,
          user_id: candidate.id,
          tenant: "ABC",
        },
      };
      let response = await resumeUpload.fetchAlljobsDropdown(payload);
      setIsAllJobsLoading(false);
      console.log(response);
      if (response.success) {
        setShowJobsModal(true);
        setCurrentJobs(response.data);
      }
    } catch (error) {
      setIsAllJobsLoading(false);
      console.log(error);
    }
  };

  const handleSubmitWithMandatoryFields = async () => {
    if (showJobsModal) {
      setShowJobsModal(false);
      setSelectedJobForApplicant("");
    }
    setShowFillModal(true);
  };
  const sendWhatsappMsg = async (jobValueFromTemplate, selectedJobFromModal = null) => {
  try {
    setSendingWhatsApp(true);
    const selectedJobValue = jobValueFromTemplate?.trim() || jobDetails?.title || "the job";
    const resolvedMphJobid = selectedJobFromModal?.mph_jobid || jobDetails?.mph_jobid || null;
    const resolvedJobId = selectedJobFromModal?.id || jobDetails?.id || null;
    let requestBody = {
      phone: candidate?.phone, // hardcoded for testing and need to change it to candidate.phone_number
	      template_payload: [
	        { "parameter_name": "candidate", "text":  candidate?.full_name ?? `${candidate?.first_name || ""} ${candidate?.last_name || ""}`},
	        { "parameter_name": "recruiter", "text": user?.displayName || "the recruiter" },
	        { "parameter_name": "job", "text": selectedJobValue }
	      ],
	      template_name: "candidate_notification",
	      body_params: [
	        { "parameter_name": "candidate", "text": candidate?.full_name ?? `${candidate?.first_name || ""} ${candidate?.last_name || ""}` },
	        { "parameter_name": "recruiter", "text": user?.displayName},
	        { "parameter_name": "job", "text": selectedJobValue }
	      ],
      button_payloads: null,
      mph_jobid: resolvedMphJobid,
      job_id: resolvedJobId,
      candidate_id: candidate?.id || candidate?.candidate_id,
      user_payload: {
        request_id: generateRequestId()
      }
    };

    const response = await RecruiterApi.sendWhatsappMsg?.(requestBody);
    if (response && response.success) {
      toast.success('WhatsApp message sent successfully');
      const newNotification = {
        message_status: "sent",
        is_responded: false,
        sent_at: new Date().toISOString(),
        response: null,
        mph_jobid: resolvedMphJobid,
        job_id: resolvedJobId,
        job_title: selectedJobValue,
	      };
	      setCandidateData((prev) => {
	        const base = prev || candidateData || candidate || {};
	        const updated = {
	          ...base,
	          whatsapp_notifications: [newNotification, ...((base.whatsapp_notifications || []))],
	          whatsapp_has_pending: true,
	        };
	        onUpdateCandidate?.(updated);
	        return updated;
	      });
    } else {
      toast.warning('Failed to send WhatsApp message. please try again later');
    }
  } catch (error) {
    console.log('Error sending WhatsApp message:', error);
  } finally {
    setSendingWhatsApp(false);
    setShowWhatsAppModal(false);
  }
};
const getWhatsAppTemplateMessage = () => {
	  const candidateFullName = candidate?.full_name ?? `${candidate?.first_name || ""} ${candidate?.last_name || ""}`;
	  return `Hi ${candidateFullName},

This is ${user?.displayName || "recruiter"} from MPH. We have an exciting opportunity for ${jobDetails?.title || "Job - JOXXXXXX"} that aligns with your experience. 
Would you like to receive a call from us to discuss more about this opportunity?.
Best regards,
MPH Team`;
};



  const toTitleCase = (str) => {
  try { 
    return str
      .toLowerCase()
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  } catch (error) {
    console.error('toTitleCase error:', error);
    return '';
  }
};

const getCandidateApplication=async ()=>{
  try {
    let requestBody = {
      candidate_id: candidateId || candidate.id,
    }
    const response = await RecruiterApi.getMphCandidateApplications?.(requestBody);
    setCandidateApplication(response.data || null);
    console.log("Candidate Application Response:", response);
    
  } catch (error) {
    console.log("Error fetching candidate application:", error);
  }
}

  const handleBookmarkClick = async (e) => {
    e.stopPropagation();
    if (bookmarkLoading) return;
    setBookmarkLoading(true);
    try {
      let requestBody = {
        payload: {
          candidate_id: candidate.id,
          job_id: jobId,
          is_tagged: !isBookmarked,
        },
        user_payload: {
          request_id: generateRequestId(),
        },
      };
      const response = await RecruiterApi.bookmarkCandidate?.(requestBody);
      if (response && response.success) {
        setIsBookmarked((prev) => !prev);
        if (onUpdateAttribute) {
          const updates = {
            id: candidate.id,
            is_tagged: !isBookmarked,
            // add other keys as needed
          };
          onUpdateAttribute(updates);
        }
      } else {
        toast.warning("Failed to tag. please try again later");
      }
    } catch (error) {
      toast.warning("Failed to tag. please try again later");
    } finally {
      setBookmarkLoading(false);
    }
  };

  const handleCloseFillModal = (closedCandidateId) => {
    if (closedCandidateId && candidate.id == closedCandidateId) {
      candidate.is_submitted = true;
    }
  };

  let candidateScore;
  if (searchType === "dropdown" && Array.isArray(similarCandidates)) {
    const matchedSim = similarCandidates.find(
      (sim) => String(sim.id) === String(candidate?.id)
    );
    candidateScore =
      typeof matchedSim?.llm_score === "number"
        ? matchedSim.llm_score.toFixed(2)
        : matchedSim?.llm_score;
  } else {
    candidateScore =
      typeof llmScore === "number" ? llmScore.toFixed(2) : llmScore;
  }
  const roundedLlmScore = candidateScore;

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center main-background">
        <Loader message="Loading candidate details" />
      </div>
    );
  }

  if (searchType === "dropdown" && jobDetailsLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center main-background">
        <Loader message="Loading job details..." />
      </div>
    );
  }

  if (searchType === "dropdown" && jobDetailsError) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center main-background">
        <div className="text-red-600 px-4 py-3 rounded mb-4 max-w-md text-center">
          {jobDetailsError}
        </div>
      </div>
    );
  }

  if (!candidate) return null;

  let filteredSimilar = Array.isArray(similarCandidates)
    ? similarCandidates.filter((c) => c.id !== candidate?.id)
    : [];

  return (
    <div className="min-h-screen main-background">
      {!isMatching && <Navbar />}
      <main
        className={`mx-auto ${
          !isMatching ? "pt-24 px-2 sm:px-4 md:px-8" : "pt-0 px-0"
        } pb-8 anim-slideUp`}
      >
        {!isMatching && (
          <Breadcrumb
            candidateName={ candidate?.full_name ?? `${candidate.first_name || ""} ${candidate.last_name || ""}`}
            query={query}
            searchType={searchType}
          />
        )}
        <div className="flex text-sm"></div>
        <div
          className="
            grid grid-cols-1
            gap-4
            mt-4
            items-start
            lg:grid-cols-3
            lg:gap-8
          "
        >
          
          <div
            className={`
              space-y-4
              p-3
              sm:p-4
              md:p-5
              bg-white
              shadow-style
              rounded-2xl
              lg:col-span-2
              ${isSidebarExpanded ? "lg:col-span-2" : "lg:col-span-3"}
              ${isMatching ? "h-[calc(100vh-8rem)]" : "h-[calc(100vh-9rem)]"}
            `}
            style={{
              maxHeight: isMatching
                ? "calc(100vh - 140px)"
                : "calc(100vh-9rem)",
              minHeight: 0,
            }}
          >
            <div className="flex gap-4 font-semibold text-gray-400 text-xs px-3">
              <div onClick={()=>setCurrentMenu('Details')} className={`
    cursor-pointer 
    ${currentMenu === "Details" ? "text-black border-b-2 border-[#B2853D]" : ""}
  `}>Details</div>
 {((isMatching && searchType !== 'description') || searchType === 'dropdown')  &&(
   <div onClick={()=>setCurrentMenu('Summary')} className={`
    cursor-pointer 
    ${currentMenu === "Summary" ? "text-black border-b-2 border-[#B2853D]" : ""}
  `}>Summary</div>
   )}

{(isMatching || searchType === 'dropdown')  &&(
   <div onClick={()=>setCurrentMenu('Questions')} className={`
    cursor-pointer 
    ${currentMenu === "Questions" ? "text-black border-b-2 border-[#B2853D]" : ""}
  `}>Questions</div>
  )}
               <div onClick={()=>setCurrentMenu('Application')} className={`
    cursor-pointer 
    ${currentMenu === "Application" ? "text-black border-b-2 border-[#B2853D]" : ""}
  `}>Application</div>
               </div>

               {currentMenu === "Details" && (

            <div
              className="bg-white p-3 sm:p-4 md:p-5 rounded-2xl shadow-style flex flex-col overflow-hidden"
              style={{ height: "calc(100vh - 215px)",  }}
            >
              <div className="flex flex-col sm:flex-row items-start gap-4 flex-shrink-0">
                {/* Avatar with gradient ring and INCOMPLETE badge if status is Incomplete */}
                <div className="relative" style={{ width: 48, height: 48 }}>
                  {/* Outer ring with gradient if incomplete */}
                  <div
                    className="absolute rounded-full"
                    style={{
                      width: "50px",
                      height: "50px",
                      left: "0px",
                      top: "0px",
                      background:
                        candidate?.status === "Incomplete"
                          ? "linear-gradient(208.83deg, #F3F4F6 47.57%, #DA819E 59.11%, #CD4772 65.72%, #C72A5C 71.92%, #C41C51 77.93%, #C10D46 85.09%)"
                          : "#F3F4F6",
                    }}
                  />
                  {/* Inner circle for image/initials */}
                  <div
                    className="absolute rounded-full flex items-center justify-center"
                    style={{
                      width: "36px",
                      height: "36px",
                      left: "7px",
                      top: "7px",
                      background: "#F3F4F6",
                      overflow: "hidden",
                    }}
                  >
                    {candidate.avatar ? (
                      <img
                        src={candidate.avatar}
                        alt={ candidate?.full_name ?? `${candidate.first_name || ""} ${candidate.last_name || ""}`}
                        className="w-12 h-12 rounded-full object-cover"
                        style={{ width: 48, height: 48 }}
                      />
                    ) : (
                      <span
                        style={{
                          fontFamily: "Raleway, sans-serif",
                          fontStyle: "normal",
                          fontWeight: 800,
                          fontSize: "20px",
                          lineHeight: "24px",
                          color: "#246B6A",
                        }}
                      >
                        {getInitials(candidate?.full_name ?? `${candidate.first_name || ""} ${candidate.last_name || ""}`)}
                      </span>
                    )}
                  </div>
                  {/* INCOMPLETE badge, positioned on the ring */}
                  {candidate?.status === "Incomplete" && (
                    <div
                      className="absolute flex items-center justify-center"
                      style={{
                        width: "44px",
                        height: "20px",
                        left: "2px",
                        top: "26px",
                        transform: "rotate(7.47deg)",
                      }}
                    >
                      <div
                        className="absolute flex items-center justify-center"
                        style={{
                          width: "auto",
                          height: "16px",
                          left: "0px",
                          top: "0px",
                          background: "#C10D46",
                          borderRadius: "8px",
                          padding: "2px 8px",
                          transform: "rotate(-7.47deg)",
                        }}
                      >
                        <span
                          style={{
                            fontFamily: "Raleway, sans-serif",
                            fontStyle: "normal",
                            fontWeight: 700,
                            fontSize: "8px",
                            lineHeight: "10px",
                            color: "#FFFFFF",
                            letterSpacing: "0.3px",
                            textTransform: "uppercase",
                          }}
                        >
                          INCOMPLETE
                        </span>
                      </div>
                    </div>
                  )}
                  {candidate?.cv_origin ==='Broadbean' && (
                    <img
                      src={require("../../../assets/BB-Logo.svg").default}
                      alt="Broadbean"
                      className="absolute bottom-0 -right-2 w-5 h-5 rounded-full border-2 border-white bg-white shadow"
                      title="Imported from Broadbean"
                    />
                  )}
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    <h2 className="text-base sm:text-lg text-gray-333 font-bold">
                      {candidate.full_name ?? `${candidate.first_name || ""} ${candidate.last_name || ""}`
} –
                      ({candidate?.years_of_experience} years)
                    </h2>
                    {candidate?.status === "Incomplete" ? (
                      <span
                        className="ml-6 relative flex items-center"
                        tabIndex={0}
                        style={{ outline: "none" }}
                        aria-label="Profile incomplete"
                        onMouseEnter={() => setShowWarningTooltip(true)}
                        onMouseLeave={() => setShowWarningTooltip(false)}
                        onFocus={() => setShowWarningTooltip(true)}
                        onBlur={() => setShowWarningTooltip(false)}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "flex-start",
                            position: "relative",
                            height: 28,
                            width: 28,
                          }}
                        >
                          <div
                            style={{
                              width: 28,
                              height: 28,
                              borderRadius: "50%",
                              background: "#FFF1F3",
                              display: "flex",
                              alignItems: "flex-start",
                              justifyContent: "center",
                              position: "relative",
                            }}
                          >
                            <FiAlertTriangle
                              size={15}
                              style={{
                                position: "absolute",
                                top: 5,
                                left: "50%",
                                transform: "translateX(-50%)",
                                color: "#C10D46",
                                background: "transparent",
                                verticalAlign: "top",
                              }}
                            />
                          </div>
                        </div>
                        {showWarningTooltip && (
                          <div
                            className="absolute left-10 z-10 rounded flex items-start gap-2 px-3 py-2 text-xs font-normal shadow-lg"
                            style={{
                              backgroundColor: "#FFF1F3",
                              color: "#C10D46",
                              top: "50%",
                              transform: "translateY(-50%)",
                              pointerEvents: "none",
                              width: "max-content",
                              overflow: "visible",
                              height: "max-content",
                              minWidth: 340,
                              maxWidth: 531,
                            }}
                          >
                            <div
                              className="absolute"
                              style={{
                                left: "-12px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                width: "0",
                                height: "0",
                                borderTop: "7px solid transparent",
                                borderBottom: "7px solid transparent",
                                borderRight: "11px solid #FFF1F3",
                                zIndex: 20,
                                pointerEvents: "none",
                              }}
                            />
                            <span
                              className="block"
                              style={{ lineHeight: 1.45 }}
                            >
                              The profile is missing mandatory details such as
                              nationality, phone number, and experience. Please
                              upload a resume containing these details to
                              proceed with shortlisting.
                            </span>
                          </div>
                        )}
                      </span>
                    ) : (
                      <SkillBadge key="active">
                        {candidate.crm_status ? candidate.crm_status : "Active"}
                      </SkillBadge>
                    )}
                  </div>
                  <p className="text-xs text-gray-999 mt-1">
                    {candidate?.highest_position}
                  </p>
                </div>
                <div className="flex items-center gap-2 mt-2">
                  <button
                    className={iconButtonStyles}
                    onClick={handleOpenResume}
                    title="Preview Resume"
                    disabled={submittingToAM || bookmarkLoading}
                    type="button"
                  >
                    {/* <FiPaperclip size={16} /> */}
                   <FileText size={18} className='mph-primary' />
                  </button>
                  {(isMatching || searchType === "dropdown") && (
                    <button
                      className={iconButtonStyles}
                      onClick={(e) => {
                        setEmailType("default");
                        handleOpenEmail(e);
                      }}
                      title={
                          candidate?.generic_email_sent_at || candidate?.email_sent_at
                            ? `Last email sent on ${new Date(
                                candidate?.generic_email_sent_at ?? candidate?.email_sent_at
                              ).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}`
                            : "Send Email"
                        }
                      type="button"
                      disabled={submittingToAM || bookmarkLoading}
                    >
                      <FiMail size={16} />
                    </button>
                  )}

                  {!isMatching && (
                    <button
                      className={iconButtonStyles}
                      onClick={(e) => {
                        setEmailType("generic");
                        handleOpenEmail(e);
                      }}
                      title={
                          candidate?.generic_email_sent_at || candidate?.email_sent_at
                            ? `Last email sent on ${new Date(
                                candidate?.generic_email_sent_at ?? candidate?.email_sent_at
                              ).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}`
                            : "Send Email"
                        }
                      type="button"
                      disabled={submittingToAM || bookmarkLoading}
                    >
                      <FiMail size={16} />
                    </button>
                  )}
                 <button
                    className={`${iconButtonStyles} text-green-500 hover:text-green-600 relative ${
                  !isValidMobileNumber() ? "opacity-50 cursor-not-allowed" : ""
                }`}
                     onClick={(e) => {
                        e.stopPropagation();
                  if (isValidMobileNumber()) {
                    setShowWhatsAppModal(true);
                  }
                    }}
                     disabled={!isValidMobileNumber()}
	                    title={
	                      !isValidMobileNumber()
	                        ? "The candidate has not provided a mobile number."
	                        : (() => {
	                            const notifications = candidateData?.whatsapp_notifications || candidate?.whatsapp_notifications;
	                            if (!notifications?.length) return "Send WhatsApp Message";
	                            const latest = notifications[0];
	                            const latestDate = latest?.sent_at ? `Last message sent on ${formatDate(latest.sent_at)}` : "";
	                            return latestDate || "Send WhatsApp Message";
	                          })()
	                    }
	                  >
	                    <FaWhatsapp size={18} />
	                    {(() => {
	                      const notifications = candidateData?.whatsapp_notifications || candidate?.whatsapp_notifications;
	                      if (!Array.isArray(notifications) || notifications.length === 0) return null;

	                      const mphJobIds = notifications.map((n) => n?.mph_jobid).filter(Boolean);
	                      const fallbackCount = mphJobIds.length > 0 ? new Set(mphJobIds).size : notifications.length;
	                      const threadCount =
	                        typeof whatsAppThreadCount === "number" ? whatsAppThreadCount : fallbackCount;
	                      if (threadCount <= 0) return null;

	                      const badgeText = threadCount > 99 ? "99+" : String(threadCount);
	                      return (
	                        <span className="absolute -top-2 -right-2 bg-emerald-600 text-white text-[10px] rounded-full h-5 min-w-5 px-1 flex items-center justify-center font-semibold border-2 border-white">
	                          {badgeText}
	                        </span>
	                      );
	                    })()}
	                  </button>
                  <div className="relative inline-block">
                    <button
                      className={`${iconButtonStyles} px-3`}
                      type="button"
                      onClick={handleOpenComment}
                      title="Comments"
                      disabled={submittingToAM || bookmarkLoading}
                    >
                      <div className="flex items-center gap-1 px-4 py-2 space-between">
                        <FiMessageCircle size={20} className="mph-primary" />
                      </div>
                    </button>
                    {candidate.comment_count > 0 && (
                      <span className="absolute -top-2 -right-2 bg-emerald-600 text-white text-xs rounded-full h-5 w-5 flex items-center justify-center font-semibold">
                        {candidate.comment_count}
                      </span>
                    )}
                  </div>
                  <>
                    <button
                      className={iconButtonStyles}
                      type="button"
                      onClick={handleOpenFormattedCVTypeModal}
                      title="Formatted CV"
                      tabIndex={0}
                      aria-label="Formatted CV"
                      disabled={
                        submittingToAM ||
                        bookmarkLoading ||
                        formattedCVLoading ||
                        resumeLoading
                      }
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="fill-white mph-primary lucide lucide-file-check-corner-icon lucide-file-check-corner"
                      >
                        <path d="M10.5 22H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h8a2.4 2.4 0 0 1 1.706.706l3.588 3.588A2.4 2.4 0 0 1 20 8v6" />
                        <path d="M14 2v5a1 1 0 0 0 1 1h5" />
                        <path d="m14 20 2 2 4-4" />
                      </svg>
                    </button>
                    {searchType == "dropdown" || isMatching && (
                      <button
                        className={iconButtonStyles}
                        onClick={handleBookmarkClick}
                        disabled={
                          bookmarkLoading || submittingToAM || fetchingSimilar
                        }
                        title={isBookmarked ? "Remove tag" : "Tag candidate"}
                        aria-label={
                          isBookmarked ? "Remove tag" : "Tag candidate"
                        }
                        tabIndex={0}
                      >
                        {bookmarkLoading || fetchingSimilar ? (
                          <span className="flex items-center">
                            <svg
                              className="animate-spin h-4 w-4 text-gray-400 inline-block"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                            >
                              <circle
                                className="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                strokeWidth="4"
                              ></circle>
                              <path
                                className="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                              ></path>
                            </svg>
                          </span>
                        ) : isBookmarked ? (
                          <FaBookmarkFilled className="mph-primary" size={16} />
                        ) : (
                          <FiBookmark className="mph-primary" size={16} />
                        )}
                      </button>
                    )}
                  </>
                  {candidate?.resume_status !== "UNDER REVIEW" &&
                    candidate?.resume_status !== "VALIDATION_FAILED" && (
                      isSubmitted ? (
                        <span className="flex items-center gap-2 text-xs font-semibold text-gray-666 border border-gray-200 px-2.5 py-1.5 rounded-full ml-2 profiler-bg">
                          <FaUserCheck /> Submitted
                        </span>
                      ) : (
                        <button
                          className={`flex items-center gap-2 text-xs font-semibold text-gray-666 border border-gray-200 px-2.5 py-1.5 rounded-full ml-2 profiler-bg ${
                            submittingToAM ? "opacity-50 cursor-not-allowed" : ""
                          }`}
                          disabled={
                            submittingToAM ||
                            bookmarkLoading ||
                            fetchingSimilar ||
                            isAllJobsLoading
                          }
                          onClick={(e) => {
                            e.stopPropagation();
                            if (!submittingToAM) handleConfirmSubmitToAM();
                          }}
                          type="button"
                          aria-label={submittingToAM ? "Submitting..." : "Submit to AM"}
                          tabIndex={0}
                        >
                          <FaUserCheck />
                          {isAllJobsLoading
                            ? "Loading..."
                            : fetchingSimilar
                            ? "Checking..."
                            : submittingToAM
                            ? "Submitting..."
                            : "Submit to AM"}
                        </button>
                      )
                    )}
                </div>
                {(isMatching || searchType == "dropdown") && (
                  <div className="text-center mt-3 sm:mt-0">
                    {fetchingSimilar ? (
                      <div className="flex items-center justify-center mt-3 w-full h-full">
                        <svg
                          className="animate-spin h-5 w-5 text-gray-500 inline-block mr-2"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          ></circle>
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                          ></path>
                        </svg>
                        <span className="text-xs text-gray-500">
                          Checking match...
                        </span>
                      </div>
                    ) : (
                      <>
                        <p className="text-xl font-bold profiler">
                          {roundedLlmScore}%
                        </p>
                        <p className="text-xs profiler">Match</p>
                      </>
                    )}
                  </div>
                )}
              </div>
               <div className="flex-shrink-0 border-b border-gray-200 mt-2">
                <div className="flex gap-4">
  {['Work Experience','Skills & Expertise','Personal Details', 'Educational Qualification'].map((tab) => (
        <button
          key={tab}
          onClick={() => setActiveTab(tab)}
          className={`px-2 py-3 text-xs font-medium transition-all relative ${
            activeTab === tab 
              ? 'text-emerald-700' 
              : 'text-gray-500 hover:text-gray-700'
          }`}
        >
          {tab === 'experience' ? 'Work Experience' : tab}
          {activeTab === tab && (
            <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-emerald-600 rounded-t-full"></div>
          )}
        </button>
      ))}

      </div>
                </div>
              <div className="flex-1 overflow-y-auto min-h-0 mt-2"
             
              >

 <div className="">

    {/* Tab Content Panels */}
    <div className="">
      {activeTab === 'Skills & Expertise' && (
        <div className="anim-fadeIn">
          {skillsPointsData ? (
            <SkillsPointsSection skillsPoints={skillsPointsData} />
          ) : (
            <>
              {/* <SkillsSection skills={candidate.skills} /> */}
              {skillsPointsLoading && (
                <p className="text-xs text-gray-500 mt-2">Fetching skill and expertise...</p>
              )}
            </>
          )}
        </div>
      )}

  {activeTab === 'Personal Details' && (
        <div className="anim-fadeIn">
          <BasicDetailsSection candidate={candidate} formatDate={formatDate} />
        </div>
      )}
      {activeTab === 'Work Experience' && (
        <div className="anim-fadeIn">
           {/* Replace this with your actual Work Experience mapping logic */}
           {candidate.work_experience?.length > 0 ? (
             <WorkExperienceSection experience={candidate.work_experience} />
           ) : (
             <p className="text-sm text-gray-500 italic p-4">No work experience details provided.</p>
           )}
        </div>
      )}

      {activeTab === 'Educational Qualification' && (
        <div className="anim-fadeIn">
          <EducationSection education={candidate.education_details} />
        </div>
      )}
    </div>
  </div>
                
                
                {/* {(isMatching || searchType == 'dropdown') && (
                  <div>
                    <div className="mph-light p-4 rounded-lg mt-4">
                      <h4 className="font-bold mph-primary flex items-center gap-2 text-sm">
                        <IoSparkles /> Why {candidate?.name?.split(' ')[0] || "They're"} a Good Fit
                      </h4>
                      <ul className="space-y-2 text-xs text-gray-333 mt-4">
                        {goodFitLoading && <li><Loader message="Loading good fit..." /></li>}
                        {!goodFitLoading && Array.isArray(goodFitData) && goodFitData.length === 0 && <li>No Good Fit observations found.</li>}
                        {Array.isArray(goodFitData) &&
                          goodFitData.map((fit, i) => (
                            <li key={i} className="flex items-start gap-2">
                              <FiChevronRight className="mph-primary mt-1 flex-shrink-0" />
                              {fit}
                            </li>
                          ))}
                      </ul>
                    </div>
                  </div>
                )} */}
              
                {showResumeModal && (
                  <ResumeModal
                    isOpen={showResumeModal}
                    onClose={handleCloseResume}
                    title={[candidate?.full_name? candidate?.full_name: `${candidate.first_name || ""} ${candidate.last_name || ""}`]
                    .filter(Boolean)
                    .join(' ') + ' - Resume'}
                    resumeUrl={resumeUrl}
                    filetype={resumeFileType}
                    loading={resumeLoading}
                    error={resumeError}
                  />
                )}
                {showEmailModal && (
                  <EmailModal
                    isOpen={showEmailModal}
                    onClose={handleCloseEmail}
                    candidateName={candidate?.full_name?? `${candidate.first_name || ""} ${candidate.last_name || ""}`}
                    candidateEmail={candidate.email}
                    jobTitle={jobDetails?.title ?? jobTitle}
                    candidateId={candidate?.id}
                    jobDuration={
                      jobDetails?.mph_contractduration ||
                      jobDetails?.contract_duration ||
                      ""
                    }
                    jobOpeningDate={
                      jobDetails?.mph_expctdstrtdate ||
                      jobDetails?.expected_start_date ||
                      ""
                    }
                    jobLocation={jobDetails?.mph_city || jobDetails?.city || ""}
                    mphJobId={jobDetails?.mph_jobid}
                    isEmailSent={
                      emailType === "generic"
                        ? Boolean(candidate?.generic_email_sent_at) || false
                        : Boolean(candidateData?.email_sent_at) || false
                    }
                    emailSentOn={
                      emailType === "generic"
                        ? candidate?.generic_email_sent_at || ""
                        : candidate?.email_sent_at || ""
                    }
                    emailSentBy={
                      emailType === "generic"
                        ? candidate?.generic_email_sent_by ??
                          candidateData?.generic_email_sent_by ??
                          candidate?.email_sent_by ??
                          candidateData?.email_sent_by ??
                          null
                        : candidateData?.email_sent_by ??
                          candidate?.email_sent_by ??
                          null
                    }
                    emailSentByFirstName={
                      emailType === "generic"
                        ? candidate?.generic_email_sent_by_first_name ??
                          candidateData?.generic_email_sent_by_first_name ??
                          candidate?.email_sent_by_first_name ??
                          candidateData?.email_sent_by_first_name ??
                          null
                        : candidateData?.email_sent_by_first_name ??
                          candidate?.email_sent_by_first_name ??
                          null
                    }
                    emailSentByLastName={
                      emailType === "generic"
                        ? candidate?.generic_email_sent_by_last_name ??
                          candidateData?.generic_email_sent_by_last_name ??
                          candidate?.email_sent_by_last_name ??
                          candidateData?.email_sent_by_last_name ??
                          null
                        : candidateData?.email_sent_by_last_name ??
                          candidate?.email_sent_by_last_name ??
                          null
                    }
                    emailSentByEmail={
                      emailType === "generic"
                        ? candidate?.generic_email_sent_by_email ??
                          candidateData?.generic_email_sent_by_email ??
                          candidate?.email_sent_by_email ??
                          candidateData?.email_sent_by_email ??
                          null
                        : candidateData?.email_sent_by_email ??
                          candidate?.email_sent_by_email ??
                          null
                    }
                    jobId={jobDetails?.id || ""}
                    type={emailType}
                    onSend={(data) => {
                      if (emailType === "generic") {
                        handleSendSearchEmail(data);
                      } else {
                        handleSendEmail(data);
                      }
                    }}
                    sending={sendingEmail}
                    sent={emailSent}
                    error={emailError}
                  />
                )}

                {showFillModal && (
                  <FillMandatoryFieldsModal
                    isOpen={showFillModal}
                    onClose={() => setShowFillModal(false)}
                    candidate={candidate}
                    mph_jobid={mphJobId}
                    onCandidateSubmitted={handleCloseFillModal}
                  />
                )}

                {showFormattedCVTypeModal && (
                  <div
                    className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30"
                    onClick={handleCloseFormattedCVTypeModal}
                  >
                    <div
                      className="w-[min(92vw,320px)] rounded-xl bg-white p-4 shadow-xl"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <div className="flex items-center justify-between gap-3 border-b border-gray-100 pb-3">
                        <h3 className="text-sm font-semibold text-gray-800">Select CV type</h3>
                        <button
                          type="button"
                          className="text-gray-500 hover:text-gray-800"
                          onClick={handleCloseFormattedCVTypeModal}
                          aria-label="Close formatted CV type modal"
                        >
                          <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
                            <path
                              d="M6 6L14 14M14 6L6 14"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                            />
                          </svg>
                        </button>
                      </div>
                      <div className="mt-4 grid grid-cols-1 gap-2">
                        {FORMATTED_CV_TYPES.map((option) => (
                          <button
                            key={option.value}
                            type="button"
                            className="w-full rounded-lg border border-gray-200 px-4 py-3 text-left text-sm font-semibold text-gray-700 transition-colors hover:border-emerald-500 hover:bg-emerald-50 hover:text-emerald-700"
                            onClick={(e) => handleShowCVModal(option.value, e)}
                          >
                            {option.label}
                          </button>
                        ))}
                      </div>
                    </div>
                  </div>
                )}

                {showCVModal && (
                  <div
                    className={modalContainerClass + " cv-modal anim-slideDown"}
                  >
                    <div
                      className={`bg-white rounded-xl shadow-lg ${modalPaddingClass} ${modalSizeClass} relative transition-all duration-200`}
                    >
                      <div className="flex items-center justify-between mb-4">
                        <div className="flex items-center gap-2 pb-3">
                          <button
                            onClick={handleCloseCVModal}
                            className="flex items-center text-xs "
                            aria-label="Go back"
                          >
                            <svg
                              className="w-4 h-4 "
                              fill="none"
                              stroke="currentColor"
                              strokeWidth={3}
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M15 19l-7-7 7-7"
                              />
                            </svg>
                            Candidate
                          </button>
                        </div>
                        {expanded ? (
                          <div className="flex gap-2">
                            <button
                              className="px-3 py-1.5 rounded-full text-xs font-semibold border border-gray-200 bg-gray-200 hover:bg-gray-200"
                              onClick={handleCloseCVModal}
                              type="button"
                            >
                              Close
                            </button>
                          </div>
                        ) : (
                          <button
                            className="top-2 right-2 text-gray-600 hover:text-gray-900 bg-gray-100 rounded-full p-1"
                            onClick={handleCloseCVModal}
                            type="button"
                            aria-label="Close CV modal"
                          >
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 20 20"
                              fill="none"
                            >
                              <path
                                d="M6 6L14 14M14 6L6 14"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                              />
                            </svg>
                          </button>
                        )}
                      </div>
                      <div className={gridColsClass}>
                        <div>
                          <div className="font-semibold text-gray-666 mb-2 text-sm flex items-center gap-1">
                             Original CV
                            {/* {resumeUrl && (
                              <button
                                type="button"
                                onClick={() => handleViewResumeClick()}
                                disabled={viewLoading}
                                aria-label="View Original CV in new tab"
                                className="ml-1 inline-flex items-center disabled:opacity-50"
                                style={{
                                  background: "none",
                                  border: "none",
                                  padding: 0,
                                  cursor: "pointer",
                                }}
                              >
                                <svg
                                  width="16"
                                  height="16"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  className="inline-block align-middle text-gray-666"
                                >
                                  <path
                                    d="M14 3h7m0 0v7m0-7L10 14"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <rect
                                    x="5"
                                    y="5"
                                    width="14"
                                    height="14"
                                    rx="2"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                  />
                                </svg>
                              </button>
                            )} */}
                            {resumeUrl && (
                              <button
                                type="button"
                                onClick={() => handleDownloadResumeClick()}
                                disabled={viewLoading}
                                aria-label="Download Original CV in new tab"
                                className="ml-1 inline-flex items-center disabled:opacity-50"
                                style={{
                                  background: "none",
                                  border: "none",
                                  padding: 0,
                                  cursor: "pointer",
                                }}
                              >
                                <svg
                                  width="18px"
                                  height="18px"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    opacity="0.5"
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M3 14.25C3.41421 14.25 3.75 14.5858 3.75 15C3.75 16.4354 3.75159 17.4365 3.85315 18.1919C3.9518 18.9257 4.13225 19.3142 4.40901 19.591C4.68577 19.8678 5.07435 20.0482 5.80812 20.1469C6.56347 20.2484 7.56459 20.25 9 20.25H15C16.4354 20.25 17.4365 20.2484 18.1919 20.1469C18.9257 20.0482 19.3142 19.8678 19.591 19.591C19.8678 19.3142 20.0482 18.9257 20.1469 18.1919C20.2484 17.4365 20.25 16.4354 20.25 15C20.25 14.5858 20.5858 14.25 21 14.25C21.4142 14.25 21.75 14.5858 21.75 15V15.0549C21.75 16.4225 21.75 17.5248 21.6335 18.3918C21.5125 19.2919 21.2536 20.0497 20.6517 20.6516C20.0497 21.2536 19.2919 21.5125 18.3918 21.6335C17.5248 21.75 16.4225 21.75 15.0549 21.75H8.94513C7.57754 21.75 6.47522 21.75 5.60825 21.6335C4.70814 21.5125 3.95027 21.2536 3.34835 20.6517C2.74643 20.0497 2.48754 19.2919 2.36652 18.3918C2.24996 17.5248 2.24998 16.4225 2.25 15.0549C2.25 15.0366 2.25 15.0183 2.25 15C2.25 14.5858 2.58579 14.25 3 14.25Z"
                                    fill="#1C274C"
                                  />
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M12 16.75C12.2106 16.75 12.4114 16.6615 12.5535 16.5061L16.5535 12.1311C16.833 11.8254 16.8118 11.351 16.5061 11.0715C16.2004 10.792 15.726 10.8132 15.4465 11.1189L12.75 14.0682V3C12.75 2.58579 12.4142 2.25 12 2.25C11.5858 2.25 11.25 2.58579 11.25 3V14.0682L8.55353 11.1189C8.27403 10.8132 7.79963 10.792 7.49393 11.0715C7.18823 11.351 7.16698 11.8254 7.44648 12.1311L11.4465 16.5061C11.5886 16.6615 11.7894 16.75 12 16.75Z"
                                    fill="#1C274C"
                                  />
                                </svg>
                              </button>
                            )}
                          </div>
                          <div
                            className={`w-full ${iframeHeightClass} border rounded`}
                          >
                            {resumeUrl ? (
                              <iframe
                                src={
                                  resumeUrl
                                    .toLowerCase()
                                    .split("?")[0]
                                    .endsWith(".docx")
                                    ? `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
                                        resumeUrl.trim().replace(/ /g, "%20")
                                      )}`
                                    : resumeUrl
                                }
                                title="Original CV"
                                className="w-full h-full rounded"
                                frameBorder="0"
                                allowFullScreen
                                style={{ backgroundColor: "white" }}
                              />
                            ) : (
                              <div className="flex flex-col items-center justify-center h-full text-gray-400 text-sm">
                                Not available
                              </div>
                            )}
                          </div>
                        </div>
                        <div>
                          <div className="font-semibold text-gray-666 mb-2 text-sm flex items-center gap-1">
                            Formatted CV
                            {formattedCVUrl && (
                              <button
                                type="button"
                                onClick={() => handleViewFormattedResumeClick()}
                                disabled={viewLoading}
                                aria-label="View Formatted CV in new tab"
                                className="ml-1 inline-flex items-center disabled:opacity-50"
                                style={{
                                  background: "none",
                                  border: "none",
                                  padding: 0,
                                  cursor: "pointer",
                                }}
                              >
                                <svg
                                  width="16"
                                  height="16"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  className="inline-block align-middle text-gray-666"
                                >
                                  <path
                                    d="M14 3h7m0 0v7m0-7L10 14"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <rect
                                    x="5"
                                    y="5"
                                    width="14"
                                    height="14"
                                    rx="2"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                  />
                                </svg>
                              </button>
                            )}
                            {formattedCVUrl && (
                              <button
                                type="button"
                                onClick={() =>
                                  handleDownloadFormattedResumeClick()
                                }
                                disabled={viewLoading}
                                aria-label="Download Formatted CV"
                                className="ml-1 inline-flex items-center disabled:opacity-50"
                                style={{
                                  background: "none",
                                  border: "none",
                                  padding: 0,
                                  cursor: "pointer",
                                }}
                              >
                                <svg
                                  width="18px"
                                  height="18px"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    opacity="0.5"
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M3 14.25C3.41421 14.25 3.75 14.5858 3.75 15C3.75 16.4354 3.75159 17.4365 3.85315 18.1919C3.9518 18.9257 4.13225 19.3142 4.40901 19.591C4.68577 19.8678 5.07435 20.0482 5.80812 20.1469C6.56347 20.2484 7.56459 20.25 9 20.25H15C16.4354 20.25 17.4365 20.2484 18.1919 20.1469C18.9257 20.0482 19.3142 19.8678 19.591 19.591C19.8678 19.3142 20.0482 18.9257 20.1469 18.1919C20.2484 17.4365 20.25 16.4354 20.25 15C20.25 14.5858 20.5858 14.25 21 14.25C21.4142 14.25 21.75 14.5858 21.75 15V15.0549C21.75 16.4225 21.75 17.5248 21.6335 18.3918C21.5125 19.2919 21.2536 20.0497 20.6517 20.6516C20.0497 21.2536 19.2919 21.5125 18.3918 21.6335C17.5248 21.75 16.4225 21.75 15.0549 21.75H8.94513C7.57754 21.75 6.47522 21.75 5.60825 21.6335C4.70814 21.5125 3.95027 21.2536 3.34835 20.6517C2.74643 20.0497 2.48754 19.2919 2.36652 18.3918C2.24996 17.5248 2.24998 16.4225 2.25 15.0549C2.25 15.0366 2.25 15.0183 2.25 15C2.25 14.5858 2.58579 14.25 3 14.25Z"
                                    fill="#1C274C"
                                  />
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M12 16.75C12.2106 16.75 12.4114 16.6615 12.5535 16.5061L16.5535 12.1311C16.833 11.8254 16.8118 11.351 16.5061 11.0715C16.2004 10.792 15.726 10.8132 15.4465 11.1189L12.75 14.0682V3C12.75 2.58579 12.4142 2.25 12 2.25C11.5858 2.25 11.25 2.58579 11.25 3V14.0682L8.55353 11.1189C8.27403 10.8132 7.79963 10.792 7.49393 11.0715C7.18823 11.351 7.16698 11.8254 7.44648 12.1311L11.4465 16.5061C11.5886 16.6615 11.7894 16.75 12 16.75Z"
                                    fill="#1C274C"
                                  />
                                </svg>
                              </button>
                            )}
                          </div>
                          <div
                            className={`w-full ${iframeHeightClass} border rounded`}
                          >
                            {formattedCVLoading ? (
                              <div className="flex flex-col items-center justify-center h-full text-gray-400 text-sm">
                                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-emerald-600 mb-2"></div>
                                Loading formatted CV...
                              </div>
                            ) : formattedCVError ? (
                              <div className="flex flex-col items-center justify-center h-full text-red-500 text-sm">
                                {formattedCVError}
                              </div>
                            ) : formattedCVUrl ? (
                              <iframe
                                src={
                                  formattedCVUrl
                                    .toLowerCase()
                                    .split("?")[0]
                                    .endsWith(".docx")
                                    ? `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(
                                        formattedCVUrl
                                          .trim()
                                          .replace(/ /g, "%20")
                                      )}`
                                    : formattedCVUrl
                                }
                                title="Formatted CV"
                                className="w-full h-full rounded"
                                frameBorder="0"
                                allowFullScreen
                                style={{ backgroundColor: "white" }}
                              />
                            ) : (
                              <div className="flex flex-col items-center justify-center h-full text-gray-400 text-sm">
                                Not available
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {showJobsModal && (
                  <JobSelectionModal
                    currentJobs={currentJobs}
                    setSelectedJob={(job) => {
                      setSelectedJobForApplicant(job);
                      setMphJobId(job?.mph_jobid);
                    }}
                    onClose={() => {
                      setSelectedJobForApplicant("");
                      setShowJobsModal(false);
                    }}
                    isOpen={showJobsModal}
                    handleSubmit={handleSubmitWithMandatoryFields}
                    selectedJob={selectedJobForApplicant}
                  />
                )}
                <CommentModal
                  isOpen={showCommentModal}
                  comment={comment}
                  setComment={setComment}
                  onSave={handleSaveComment}
                  onClose={handleCloseComment}
                  candidateId={candidate.id}
                  onUpdateCandidate={handleUpdateComment}
                  jobId={jobId}
                />
                {showWhatsAppModal && (
                 <WhatsAppModal
                isOpen={showWhatsAppModal}
                onClose={() => setShowWhatsAppModal(false)}
                onSend={sendWhatsappMsg}
                recruiterName={toTitleCase(user?.displayName)}
                candidateName={candidate?.full_name ?? `${candidate.first_name || ""} ${candidate.last_name || ""}`}
                jobDetails={jobDetails}
                templateMessage={getWhatsAppTemplateMessage()}
                sending={sendingWhatsApp}
                recruiterId={user?.id}
                notifications={candidateData?.whatsapp_notifications || candidate?.whatsapp_notifications || []}
                candidateId={candidateData?.id || candidate?.id}
              />
                )}
               
              </div>
            </div>
               )}
               {currentMenu=== "Application" && (
                 <div
              className="bg-white p-3 sm:p-4 md:p-5 rounded-2xl shadow-style"
              style={{ height: "95%", overflowY: "auto" }}
            >
           {candidateApplication && candidateApplication.length > 0 ? (
  <table className="min-w-full divide-y rounded-2xl divide-gray-200">
    <thead className="bg-gray-50 rounded-2xl">
      <tr>
        <th className="px-4 py-3 text-left text-[0.7rem] font-semibold text-gray-500 uppercase tracking-wider">
          job ID
        </th>
        <th className="px-4 py-3 text-left text-[0.7rem] font-semibold text-gray-500 uppercase tracking-wider">
          Position
        </th>
        <th className="px-4 py-3 text-left text-[0.7rem] font-semibold text-gray-500 uppercase tracking-wider">
          Client
        </th>
        <th className="px-4 py-3 text-left text-[0.7rem] font-semibold text-gray-500 uppercase tracking-wider">
          Location
        </th>
        <th className="px-4 py-3 text-left text-[0.7rem] font-semibold text-gray-500 uppercase tracking-wider">
          Account Manager
        </th>
        <th className="px-4 py-3 text-left text-[0.7rem] font-semibold text-gray-500 uppercase tracking-wider">
          Recruiter
        </th>
        <th className="px-4 py-3 text-left text-[0.7rem] font-semibold text-gray-500 uppercase tracking-wider">
          Status
        </th>
        <th className="px-4 py-3 text-left text-[0.7rem] font-semibold text-gray-500 uppercase tracking-wider">
          Blacklist Client
        </th>
        <th className="px-4 py-3 text-left text-[0.7rem] font-semibold text-gray-500 uppercase tracking-wider">
          Blacklist Country
        </th>
        <th className="px-4 py-3 text-left text-[0.7rem] font-semibold text-gray-500 uppercase tracking-wider">
          Blacklist Reason
        </th>
      </tr>
    </thead>
    <tbody className="bg-white divide-y divide-gray-200">
      {candidateApplication.map((app) => (
        <tr key={app.position.id} className="hover:bg-gray-50">
          <td className="px-4 py-4 whitespace-nowrap text-[0.7rem]">
  {app.position.mph_jobid ? (
    <button
      disabled={!app.position?.job_exist}
      onClick={() => window.open(`/jobs/jobDetails/${app.position.mph_jobid}`, '_blank')}
      className="text-blue-600 hover:text-blue-800 hover:underline cursor-pointer disabled:text-gray-400 disabled:cursor-not-allowed"
    >
      {app.position.mph_jobid}
    </button>
  ) : (
    <span className="text-gray-900">-</span>
  )}
</td>
          <td className="px-4  whitespace-nowrap  py-4 text-xs text-gray-900">
            {extractPositionName(app.position.title)}
          </td>
          <td className="px-4 py-4 whitespace-nowrap text-[0.7rem] text-gray-900">
            {app.client.name}
          </td>
          <td className="px-4 py-4 whitespace-nowrap text-[0.7rem] text-gray-900">
            {app.location.name}
          </td>
          <td className="px-4 py-4 whitespace-nowrap text-[0.7rem] text-gray-900">
            {app.account_manager.name}
          </td>
          <td className="px-4 py-4 whitespace-nowrap text-[0.7rem] text-gray-900">
            {app.position.recruiters}
          </td>
          <td className="px-4 py-4 whitespace-nowrap">
            <span className={`px-3 py-1 inline-flex text-[0.7rem] leading-5 font-semibold rounded-full ${getStatusColor(app.application_status.status)}`}>
              {app.application_status.status}
            </span>
          </td>
          <td className="px-4 py-4 whitespace-nowrap text-[0.7rem] text-gray-900">
            {app.blacklist_info.client.name || 'Nil'}
          </td>
          <td className="px-4 py-4 whitespace-nowrap text-[0.7rem] text-gray-900">
            {app.blacklist_info.country.name || 'Nil'}
          </td>
          <td className="px-4 py-4 whitespace-nowrap text-[0.7rem] text-gray-900">
            {app.blacklist_info.reason || 'Nil'}
          </td>
        </tr>
      ))}
    </tbody>
  </table>
) : (
  <div className="flex w-full h-full items-center justify-center py-12 text-gray-500">
    <p className="text-sm">No data found</p>
  </div>
)}

            </div>

               )}
       {currentMenu === "Summary" && (
        <div
          className="bg-white p-3 sm:p-4 md:p-5 rounded-2xl shadow-style"
          style={{ height: "95%", overflowY: "auto" }}
        >
          {(isMatching || searchType === "dropdown") && (
            <div className=" h-full space-y-4">
              {!goodFitLoading && (
                <div className="flex items-center gap-2 mb-5 pb-3 border-b border-gray-200">
                  <h4
                        className="font-bold   flex items-center gap-2 text-md mph-primary"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "0.5rem",
                          fontWeight: "bold",
                        
                        }}
                      >
                        <IoSparkles /> Candidate Fit Summary
                      </h4>
                </div>
              )}

              {goodFitLoading && (
                <div className="w-full flex h-full items-center justify-center"> 
                          <Loader message="Loading good fit..." />
                          </div>
                        )}

              {!goodFitLoading &&
                Array.isArray(goodFitData) &&
                goodFitData.length === 0 && (
                  <div className="text-center py-10 bg-gray-50 rounded-lg border border-gray-200">
                    <IoInformationCircle className="text-gray-300 text-3xl mx-auto mb-2" />
                    <p className="text-gray-500 text-sm">No candidate fit observations available.</p>
                  </div>
                )}

              {!goodFitLoading &&
                Array.isArray(goodFitData) &&
                goodFitData.map((fit, i) => {
                  // Extract key sections for special rendering
                  const lines = fit.split('\n');
                  const summary = lines.find(l => l.startsWith('One-line summary:'))?.replace('One-line summary:', '').trim();
                  const verdict = lines.find(l => l.startsWith('Fit verdict:'))?.replace('Fit verdict:', '').trim();
                  const rationale = lines.find(l => l.startsWith('Rationale:'))?.replace('Rationale:', '').trim();

                  return (
                    <div
                      key={i}
                      className="bg-white border border-gray-200 rounded-lg overflow-hidden shadow-sm"
                      style={{
                        marginTop: i > 0 ? "1rem" : "0",
                      }}
                    >
                      {/* Header Section */}
                      {(summary || verdict) && (
                        <div className="bg-gradient-to-r from-slate-50 to-gray-50 p-4 border-b border-gray-200">
                          {summary && (
                            <p className="text-gray-700 text-sm font-medium mb-2.5 leading-relaxed">
                              {summary}
                            </p>
                          )}
                          {verdict && (
                            <div className="flex items-start gap-2 mb-2">
                              {verdict.toLowerCase().includes('strong') ? (
                                <IoCheckmarkCircle className="text-green-600 text-base flex-shrink-0 mt-0.5" />
                              ) : (
                                <IoAlertCircle className="text-amber-600 text-base flex-shrink-0 mt-0.5" />
                              )}
                              <div className="flex-1">
                                <span className="text-gray-600 text-sm">Assessment: </span>
                                <span className={`font-semibold text-sm ${
                                  verdict.toLowerCase().includes('strong') 
                                    ? 'text-green-700' 
                                    : 'text-amber-700'
                                }`}>
                                  {verdict}
                                </span>
                              </div>
                            </div>
                          )}
                          {rationale && (
                            <p className="text-sm text-gray-600 leading-relaxed bg-white/60 p-2.5 rounded border-l-2 border-indigo-400">
                              {rationale}
                            </p>
                          )}
                        </div>
                      )}

                      {/* Main Content */}
                      <div className="p-4">
                        <ReactMarkdown
                          remarkPlugins={[remarkGfm]}
                          components={{
                            table: ({ node, ...props }) => (
                              <div className="overflow-x-auto my-3 rounded border border-gray-200">
                                <table
                                  className="min-w-full divide-y divide-gray-200"
                                  {...props}
                                />
                              </div>
                            ),
                            thead: ({ node, ...props }) => (
                              <thead className="bg-gray-50" {...props} />
                            ),
                            th: ({ node, ...props }) => (
                              <th
                                className="px-3 py-2 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider"
                                {...props}
                              />
                            ),
                            td: ({ node, ...props }) => (
                              <td
                                className="px-3 py-2 text-xs text-gray-700 border-b border-gray-100"
                                style={{ verticalAlign: "top" }}
                                {...props}
                              />
                            ),
                            tr: ({ node, ...props }) => (
                              <tr
                                className="hover:bg-gray-50 transition-colors duration-150"
                                {...props}
                              />
                            ),
                            h1: ({ node, ...props }) => (
                              <h1
                                className="text-base font-bold text-gray-900 mt-4 mb-2 pb-1.5 border-b border-indigo-500"
                                {...props}
                              />
                            ),
                            h2: ({ node, ...props }) => (
                              <h2
                                className="text-sm font-bold text-gray-800 mt-3 mb-1.5 uppercase tracking-wide"
                                {...props}
                              />
                            ),
                            h3: ({ node, ...props }) => (
                              <h3
                                className="text-sm font-semibold text-gray-700 mt-2.5 mb-1"
                                {...props}
                              />
                            ),
                            p: ({ node, ...props }) => (
                              <p
                                className="text-xs text-gray-700 leading-relaxed my-1.5"
                                {...props}
                              />
                            ),
                            ul: ({ node, ...props }) => (
                              <ul
                                className="list-disc list-inside space-y-0.5 my-2 ml-1"
                                {...props}
                              />
                            ),
                            ol: ({ node, ...props }) => (
                              <ol
                                className="list-decimal list-inside space-y-0.5 my-2 ml-1"
                                {...props}
                              />
                            ),
                            li: ({ node, ...props }) => (
                              <li
                                className="text-xs text-gray-700 leading-relaxed"
                                {...props}
                              />
                            ),
                            code: ({ node, inline, ...props }) => 
                              inline ? (
                                <code
                                  className="bg-gray-100 text-indigo-700 px-1 py-0.5 rounded text-[11px] font-mono"
                                  {...props}
                                />
                              ) : (
                                <code
                                  className="block bg-gray-900 text-gray-100 p-2 rounded text-[11px] font-mono overflow-x-auto my-2"
                                  {...props}
                                />
                              ),
                            strong: ({ node, ...props }) => (
                              <strong
                                className="font-semibold text-gray-900"
                                {...props}
                              />
                            ),
                            em: ({ node, ...props }) => (
                              <em
                                className="italic text-gray-600"
                                {...props}
                              />
                            ),
                            blockquote: ({ node, ...props }) => (
                              <blockquote
                                className="border-l-2 border-indigo-400 pl-3 py-1.5 my-2 bg-indigo-50/50 text-gray-700 text-xs italic"
                                {...props}
                              />
                            ),
                          }}
                        >
                          {fit}
                        </ReactMarkdown>
                      </div>
                    </div>
                  );
                })}
            </div>
          )}
        </div>
      )}

      {currentMenu === "Questions" && (
       <>
        {goodFitLoading && (
                <div className="w-full flex h-full items-center justify-center"> 
                          <Loader message="Loading good fit..." />
                          </div>
                        )}
        {!goodFitLoading && (isMatching || searchType == "dropdown") && ( 
                  <ScreeningTabs screeningData={prerequisiteQuestions} />
                )}
       </>

        )}

               
          </div>
          {isSidebarExpanded && (
            <aside className="bg-white p-3 sm:p-4 md:p-6 rounded-2xl shadow-sm lg:col-span-1 w-full h-[calc(100vh-9rem)] anim-slideLeft">
              <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-4 gap-2">
                <h3 className="text-base sm:text-lg font-semibold mph-primary">
                  Other candidates
                </h3>
                {(() => {
                  if (
                    Array.isArray(similarCandidates) &&
                    similarCandidates.length === 1 &&
                    similarCandidates[0]?.id === candidate?.id &&
                    !fetchingSimilar
                  ) {
                    return null;
                  }
                  if (isMatching) {
                    return (
                      <div
                        className="text-sm cursor-pointer font-semibold mph-primary"
                        onClick={handleViewAllClick}
                      >
                        View all
                      </div>
                    );
                  } else {
                    return (
                      <Link
                        to={{
                          pathname: "/candidates",
                          search:
                            query && searchType
                              ? `?query=${encodeURIComponent(
                                  query
                                )}&type=${encodeURIComponent(searchType)}`
                              : "",
                        }}
                        className="text-sm font-semibold mph-primary"
                      >
                        View all
                      </Link>
                    );
                  }
                })()}
              </div>
              <div
                className="space-y-4 overflow-y-auto max-h-[calc(100vh-15rem)] overflow-x-hidden"
                ref={similarListRef}
              >
                {(() => {
                  if (!Array.isArray(similarCandidates)) return null;

                  // Use filteredSimilar computed above, always remove current candidate
                  if (
                    (similarCandidates.length === 1 &&
                      filteredSimilar.length === 0) ||
                    (filteredSimilar.length === 0 && !fetchingSimilar)
                  ) {
                    return (
                      <div className="text-center text-xs text-gray-666 py-8">
                        No other similar candidates to display.
                      </div>
                    );
                  }

                  return filteredSimilar
                    .filter((c) => {
                      const status = (c?.crm_status || "").toLowerCase();
                      return (
                        !status.includes("incomplete") &&
                        !status.includes("blacklisted")
                      );
                    })
                    .map((c) => (
                      <SimilarCandidateCard
                        key={c.id}
                        candidate={c}
                        pageType={pageType}
                        onClick={() => handleCandidateSelect(c)}
                        jobId={jobId}
                        jobDetails={jobDetails}
                        searchType={searchType}
                        onUpdateCandidate={onUpdateCandidate}
                      />
                    ));
                })()}
                {!isMatching && fetchingSimilar && (
                  <Loader message="Loading similar candidates" />
                )}
                {/* {!isMatching &&
                  !query &&
                  hasMore &&
                  !fetchingSimilar &&
                  searchType !== "dropdown" && (
                    <div className="flex justify-center py-2">
                      <Loader message="Loading more" />
                    </div>
                  )} */}
              </div>
            </aside>
          )}
          <div
            className="hidden"
            ref={similarListRef}
          />
        </div>
        <button
          onClick={() => setIsSidebarExpanded(!isSidebarExpanded)}
          className="fixed right-4 top-1/2 transform -translate-y-1/2 bg-gradient text-white p-2 rounded-full shadow-lg hover:shadow-xl z-10"
          title={
            isSidebarExpanded
              ? "Hide Other Candidates"
              : "Show Other Candidates"
          }
        >
          <svg
            className="w-5 h-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            style={{
              transform: isSidebarExpanded ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.3s",
            }}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M15 19l-7-7 7-7"
            />
          </svg>
        </button>
      </main>
      
    </div>
  );
};
const formatDate = (dateString) => {
  if (!dateString) return "-";
  const date = new Date(dateString);

  const day = String(date.getDate()).padStart(2, "0");
  const month = date.toLocaleString("en-US", { month: "short" });
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};


export default CandidateDetailPage;
